var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4Luzara(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "130.78pt",
    height: "64.647pt",
    viewBox: "0 0 130.78 64.647",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.6875 0h2.6094v0.40625l-1.7031 2.1094s-0.035156 0.046875-0.10938 0.14062c-0.082031 0.09375-0.15625 0.17578-0.21875 0.25h1.8438v0.39062h-2.375v-0.39062l1.8594-2.2812 0.20312-0.23438h-2.1094z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0781 0h0.48438l0.39062 1h1.375l0.375-1h0.45312l-1.2656 3.2969h-0.46875zm1.0156 1.3438c0.27344 0.71875 0.42188 1.125 0.45312 1.2188 0.03125 0.10156 0.070313 0.23438 0.10938 0.39062h0.015625c0.042969-0.21875 0.10156-0.42188 0.17188-0.60938l0.375-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.2812 0h0.54688c0.33594 0.51953 0.54297 0.83594 0.625 0.95312 0.074219 0.125 0.15625 0.22656 0.25 0.3125 0.085937 0.082031 0.16797 0.13281 0.25 0.15625 0.074219 0.019531 0.17188 0.03125 0.29688 0.03125h0.5v-1.4531h0.4375v3.2969h-1.4531c-0.19531 0-0.36328-0.015625-0.5-0.046875-0.13281-0.023438-0.25391-0.074219-0.35938-0.15625-0.10156-0.074219-0.17969-0.17188-0.23438-0.29688-0.050781-0.125-0.078125-0.26172-0.078125-0.40625 0-0.25 0.078125-0.45312 0.23438-0.60938 0.15625-0.14844 0.38672-0.23438 0.6875-0.26562v-0.015625c-0.21875-0.09375-0.42578-0.29688-0.625-0.60938zm2.4688 1.8438h-0.92188c-0.19531 0-0.34766 0.015625-0.45312 0.046875-0.11328 0.03125-0.20312 0.09375-0.26562 0.1875s-0.09375 0.19531-0.09375 0.3125c0 0.15625 0.058594 0.28516 0.17188 0.39062 0.10547 0.10156 0.28125 0.15625 0.53125 0.15625h1.0312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.9531 0h0.4375v1.5469h1.7031v-1.5469h0.4375v3.2969h-0.4375v-1.3594h-1.7031v1.3594h-0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.7969 3.3594c-0.45703 0-0.83203-0.15625-1.125-0.46875-0.30078-0.3125-0.45312-0.73047-0.45312-1.25 0-0.51172 0.15234-0.92188 0.45312-1.2344 0.29297-0.3125 0.66797-0.46875 1.125-0.46875 0.48047 0 0.86719 0.16016 1.1562 0.48438 0.28125 0.32031 0.42188 0.71875 0.42188 1.1875 0 0.53906-0.14453 0.96875-0.4375 1.2812-0.28906 0.3125-0.67188 0.46875-1.1406 0.46875zm0-3.0469c-0.33203 0-0.60156 0.11328-0.8125 0.34375-0.20703 0.23828-0.3125 0.56641-0.3125 0.98438 0 0.42578 0.10938 0.75391 0.32812 0.98438 0.21094 0.23828 0.47656 0.35938 0.79688 0.35938 0.32422 0 0.59375-0.11719 0.8125-0.34375 0.21094-0.23047 0.3125-0.57812 0.3125-1.0469 0-0.375-0.10156-0.68359-0.3125-0.92188-0.20703-0.24219-0.47656-0.35938-0.8125-0.35938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.4844 0h0.40625v2.7656h0.015625l0.95312-2.7656h0.39062l0.9375 2.8125h0.015625v-2.8125h0.42188v3.2969h-0.65625l-0.78125-2.3281c-0.09375-0.26172-0.14453-0.42969-0.15625-0.5-0.039062 0.13281-0.10156 0.3125-0.1875 0.53125l-0.78125 2.2969h-0.57812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.8281 0h2.4688v3.2969h-2.3906v-0.39062h1.9531v-1h-1.8281v-0.39062h1.8281v-1.125h-2.0312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.3125 2.3281c0.023438 0.20703 0.10156 0.36328 0.23438 0.46875 0.125 0.11328 0.3125 0.17188 0.5625 0.17188 0.23047 0 0.41797-0.042969 0.5625-0.125 0.13672-0.085938 0.20312-0.21094 0.20312-0.375 0-0.14844-0.050781-0.25781-0.15625-0.32812-0.11328-0.0625-0.32812-0.13281-0.64062-0.20312-0.26953-0.054688-0.48828-0.10938-0.65625-0.17188-0.17578-0.0625-0.32031-0.16406-0.4375-0.29688-0.125-0.13672-0.1875-0.3125-0.1875-0.53125 0-0.29297 0.11719-0.53125 0.34375-0.71875 0.21875-0.1875 0.51172-0.28125 0.875-0.28125 0.46094 0 0.80469 0.10156 1.0312 0.3125 0.23047 0.20703 0.35547 0.47656 0.375 0.8125l-0.42188 0.03125c-0.019531-0.26172-0.11719-0.45312-0.29688-0.57812-0.1875-0.11719-0.41016-0.17188-0.67188-0.17188-0.25 0-0.44531 0.046875-0.59375 0.14062-0.15625 0.10156-0.23438 0.23828-0.23438 0.40625 0 0.1875 0.085937 0.32031 0.25 0.40625 0.15625 0.082031 0.42188 0.16016 0.79688 0.23438 0.36719 0.082031 0.63281 0.19531 0.79688 0.34375 0.15625 0.14453 0.23438 0.33203 0.23438 0.5625 0 0.26953-0.097656 0.48828-0.29688 0.65625-0.20703 0.17578-0.49219 0.26562-0.85938 0.26562-0.36328 0-0.65625-0.089844-0.875-0.26562-0.22656-0.16797-0.34766-0.41406-0.35938-0.73438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.35938 3.2969h-1.2344c-0.19531 0-0.36719-0.011719-0.51562-0.03125-0.14453-0.023437-0.27344-0.074219-0.39062-0.15625-0.125-0.074219-0.21875-0.18359-0.28125-0.32812-0.0625-0.13672-0.09375-0.28125-0.09375-0.4375 0-0.30469 0.10156-0.54688 0.29688-0.73438 0.19922-0.17969 0.51172-0.26562 0.9375-0.26562h0.84375v-1.3438h0.4375zm-0.4375-1.5625h-0.84375c-0.51953 0-0.78125 0.19531-0.78125 0.59375 0 0.13281 0.039063 0.25 0.10938 0.34375 0.0625 0.10156 0.14844 0.16406 0.25 0.1875 0.09375 0.03125 0.24219 0.046875 0.4375 0.046875h0.82812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.9531 0h0.4375l1.7344 2.5938v-2.5938h0.42188v3.2969h-0.45312l-1.7188-2.5938h-0.015625v2.5938h-0.40625zm0.5 4.0781c0-0.16797 0.042969-0.29688 0.125-0.39062 0.085937-0.085938 0.1875-0.125 0.3125-0.125 0.074219 0 0.13672 0.00391 0.1875 0.015625 0.042969 0.019531 0.09375 0.054687 0.15625 0.10938 0.10547 0.0625 0.1875 0.09375 0.25 0.09375 0.125 0 0.1875-0.074219 0.1875-0.21875h0.28125c0 0.16406-0.039063 0.28906-0.125 0.375-0.09375 0.09375-0.20312 0.14062-0.32812 0.14062-0.09375 0-0.19531-0.039063-0.3125-0.10938-0.11328-0.0625-0.20703-0.09375-0.28125-0.09375-0.10156 0-0.16406 0.066406-0.1875 0.20312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.875 0c0-0.1875 0.039062-0.33203 0.10938-0.4375 0.074219-0.10156 0.16406-0.17578 0.26562-0.21875l0.10938 0.17188c-0.16406 0.074219-0.25 0.23438-0.25 0.48438h0.21875v0.46875h-0.45312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.875 0h0.46875v0.46875h-0.46875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0469 3.2969 1.2969-3.2969h0.4375l1.2812 3.2969h-0.46875l-0.85938-2.3906c-0.0625-0.15625-0.11719-0.33984-0.17188-0.54688-0.050781 0.17578-0.10938 0.35938-0.17188 0.54688l-0.89062 2.3906z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.375 3.2969h-1.1406c-0.19531 0-0.36328-0.011719-0.5-0.03125-0.14453-0.023437-0.28516-0.074219-0.42188-0.15625-0.13281-0.074219-0.25-0.17969-0.34375-0.3125-0.09375-0.13672-0.16406-0.29688-0.21875-0.48438-0.0625-0.17969-0.09375-0.39062-0.09375-0.64062 0-0.49219 0.11719-0.89062 0.34375-1.2031 0.23047-0.3125 0.625-0.46875 1.1875-0.46875h1.1875zm-0.4375-2.9062h-0.70312c-0.14453 0-0.26953 0.007813-0.375 0.03125-0.11328 0.019531-0.22656 0.066406-0.34375 0.14062-0.125 0.082031-0.22266 0.21094-0.29688 0.39062-0.070312 0.1875-0.10938 0.42578-0.10938 0.71875 0 0.16406 0.015625 0.32031 0.046875 0.46875 0.023438 0.14453 0.074219 0.27344 0.15625 0.39062 0.074219 0.11328 0.16406 0.19531 0.26562 0.25 0.10547 0.0625 0.21094 0.097656 0.3125 0.10938 0.09375 0.00781 0.21484 0.015625 0.35938 0.015625h0.6875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.85938 0h0.4375v3.2969h-0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.9531 1.3906c0-0.16797 0.011719-0.32422 0.03125-0.46875 0.011719-0.14844 0.058594-0.29688 0.14062-0.45312 0.085938-0.14844 0.21484-0.27344 0.39062-0.375 0.17969-0.10156 0.41797-0.15625 0.71875-0.15625 0.29297 0 0.53125 0.046875 0.71875 0.14062 0.17969 0.09375 0.30859 0.20703 0.39062 0.34375 0.085938 0.14453 0.14062 0.29688 0.17188 0.45312 0.023437 0.15625 0.03125 0.32812 0.03125 0.51562v1.9062h-0.4375v-1.9062c0-0.19922-0.015625-0.37109-0.046875-0.51562-0.03125-0.13672-0.10156-0.26172-0.21875-0.375-0.125-0.10547-0.3125-0.15625-0.5625-0.15625-0.25781 0-0.45312 0.039062-0.57812 0.125-0.13281 0.09375-0.21875 0.21094-0.25 0.35938-0.039063 0.14453-0.0625 0.33203-0.0625 0.5625v1.9062h-0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.7188 2.9062h1.0938v-2.9062h0.4375v2.9062h1.0938v0.39062h-2.625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.1562 1.0469c0.10547-0.375 0.27734-0.65625 0.51562-0.84375 0.24219-0.17969 0.52734-0.26562 0.85938-0.26562 0.54297 0 0.9375 0.16406 1.1875 0.5 0.24219 0.34375 0.35938 0.75391 0.35938 1.2344 0 0.53125-0.14453 0.94141-0.4375 1.2344-0.28906 0.30078-0.66406 0.45312-1.125 0.45312-0.3125 0-0.58203-0.085937-0.8125-0.25-0.22656-0.16797-0.39062-0.40625-0.48438-0.71875l0.42188-0.09375c0.074219 0.22656 0.1875 0.39844 0.34375 0.51562 0.14844 0.11328 0.32812 0.17188 0.54688 0.17188 0.35547 0 0.625-0.12109 0.8125-0.35938 0.1875-0.24219 0.28125-0.55859 0.28125-0.95312 0-0.46094-0.097656-0.80469-0.29688-1.0312-0.19531-0.21875-0.45312-0.32812-0.76562-0.32812-0.25781 0-0.46875 0.066406-0.625 0.20312-0.16406 0.14453-0.28125 0.35938-0.34375 0.64062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.7969 3.3594c-0.45703 0-0.83203-0.15625-1.125-0.46875-0.30078-0.3125-0.45312-0.73047-0.45312-1.25 0-0.51172 0.15234-0.92188 0.45312-1.2344 0.29297-0.3125 0.66797-0.46875 1.125-0.46875 0.48047 0 0.86719 0.16016 1.1562 0.48438 0.28125 0.32031 0.42188 0.71875 0.42188 1.1875 0 0.53906-0.14453 0.96875-0.4375 1.2812-0.28906 0.3125-0.67188 0.46875-1.1406 0.46875zm0-3.0469c-0.33203 0-0.60156 0.11328-0.8125 0.34375-0.20703 0.23828-0.3125 0.56641-0.3125 0.98438 0 0.42578 0.10938 0.75391 0.32812 0.98438 0.21094 0.23828 0.47656 0.35938 0.79688 0.35938 0.32422 0 0.59375-0.11719 0.8125-0.34375 0.21094-0.23047 0.3125-0.57812 0.3125-1.0469 0-0.375-0.10156-0.68359-0.3125-0.92188-0.20703-0.24219-0.47656-0.35938-0.8125-0.35938zm-0.57812 3.8438 0.5-0.64062h0.32812l-0.29688 0.64062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.9531 0h0.4375l1.7344 2.5938v-2.5938h0.42188v3.2969h-0.45312l-1.7188-2.5938h-0.015625v2.5938h-0.40625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0469 0h0.54688l0.65625 0.9375c0.15625 0.22656 0.25781 0.37891 0.29688 0.45312h0.015625c0-0.023437 0.32812-0.48438 0.98438-1.3906h0.53125l-1.2812 1.7188 1.125 1.5781h-0.51562l-0.70312-0.98438c-0.070313-0.10547-0.125-0.19531-0.15625-0.26562-0.0625 0.10156-0.375 0.51953-0.9375 1.25h-0.46875l1.1562-1.5469z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.5938 2.9062h1.7812v-1.0156h-1.5469v-0.39062h1.5469v-1.5h0.4375v3.2969h-2.2188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.3906 0.98438h1.2344v0.40625h-1.2344z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.7344 0h0.40625v2.5781c0.21094-0.1875 0.48047-0.35156 0.8125-0.48438v0.39062c-0.45703 0.21875-0.77344 0.49219-0.95312 0.82812h-0.26562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.73438 1.9844c-0.19531 0.13281-0.40625 0.20312-0.625 0.20312-0.26953 0-0.50391-0.10156-0.70312-0.29688-0.20703-0.1875-0.3125-0.44531-0.3125-0.76562 0-0.33594 0.10547-0.61719 0.3125-0.84375 0.21094-0.23047 0.48047-0.34375 0.8125-0.34375 0.27344 0 0.51172 0.078125 0.71875 0.23438 0.19922 0.15625 0.3125 0.38281 0.34375 0.6875l-0.42188 0.03125c-0.039063-0.21094-0.11328-0.36719-0.21875-0.46875-0.11328-0.09375-0.25391-0.14062-0.42188-0.14062-0.20703 0-0.375 0.078125-0.5 0.23438s-0.1875 0.34375-0.1875 0.5625c0 0.22656 0.070312 0.41016 0.20312 0.54688 0.125 0.13281 0.28906 0.20312 0.48438 0.20312 0.26172 0 0.46484-0.10547 0.60938-0.3125l0.375 0.046875-0.3125 1.6875h-1.6406v-0.39062h1.3125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.75 1.7812c-0.19531-0.042969-0.34766-0.14062-0.45312-0.29688-0.10156-0.15625-0.15625-0.32812-0.15625-0.51562 0-0.30469 0.10938-0.55469 0.32812-0.75 0.21875-0.1875 0.48047-0.28125 0.78125-0.28125 0.29297 0 0.53125 0.082031 0.71875 0.25 0.1875 0.17578 0.29688 0.40625 0.32812 0.6875l-0.40625 0.046875c-0.039063-0.21875-0.11328-0.38281-0.21875-0.48438-0.10156-0.10547-0.24219-0.15625-0.42188-0.15625-0.1875 0-0.34766 0.0625-0.48438 0.1875-0.13281 0.13281-0.20312 0.30078-0.20312 0.5 0 0.17578 0.0625 0.32812 0.1875 0.45312 0.11719 0.125 0.27344 0.1875 0.46875 0.1875 0.074219 0 0.16797-0.015625 0.28125-0.046875l-0.046875 0.35938c-0.10156 0-0.1875 0.00391-0.25 0.015625-0.0625 0.007812-0.12891 0.035156-0.20312 0.078125-0.082031 0.039063-0.14844 0.097656-0.20312 0.17188-0.050781 0.070312-0.078125 0.16406-0.078125 0.28125 0 0.16406 0.058594 0.28906 0.17188 0.375 0.10547 0.09375 0.22656 0.14062 0.35938 0.14062 0.16797 0 0.30469-0.054687 0.40625-0.15625 0.10547-0.10547 0.16797-0.25 0.1875-0.4375l0.40625 0.0625c-0.050781 0.28906-0.16406 0.50391-0.34375 0.64062-0.17578 0.14453-0.39062 0.21875-0.64062 0.21875-0.26953 0-0.5-0.085938-0.6875-0.25-0.1875-0.16797-0.28125-0.37109-0.28125-0.60938 0-0.30469 0.15234-0.52344 0.45312-0.65625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.3438 0.78125h0.4375v-0.78125h0.40625v0.78125h1.4375v0.375l-1.5156 2.1406h-0.32812v-2.1406h-0.4375zm0.84375 0.375v1.5h0.015625l1.0156-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.2812 3.3125c-0.71875 0-1.0781-0.5625-1.0781-1.6875 0-0.5625 0.09375-0.98438 0.28125-1.2656s0.45312-0.42188 0.79688-0.42188c0.71875 0 1.0781 0.5625 1.0781 1.6875 0 0.57031-0.09375 0.99219-0.28125 1.2656-0.1875 0.28125-0.45312 0.42188-0.79688 0.42188zm0-3.0312c-0.21875 0-0.37891 0.10156-0.48438 0.3125-0.11328 0.20703-0.17188 0.55078-0.17188 1.0312 0 0.33203 0.027344 0.59375 0.078125 0.78125 0.042969 0.19531 0.11719 0.34375 0.21875 0.4375 0.09375 0.09375 0.21484 0.14062 0.35938 0.14062 0.21875 0 0.38672-0.10938 0.5-0.32812 0.10547-0.21094 0.15625-0.55469 0.15625-1.0312 0-0.32422-0.019531-0.58594-0.0625-0.78125-0.050781-0.1875-0.125-0.32812-0.21875-0.42188-0.10156-0.09375-0.22656-0.14062-0.375-0.14062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.60938 1.7031c-0.17578 0.28906-0.4375 0.4375-0.78125 0.4375-0.26953 0-0.5-0.10156-0.6875-0.29688-0.19531-0.19922-0.29688-0.45312-0.29688-0.76562s0.09375-0.58594 0.28125-0.8125c0.1875-0.21875 0.4375-0.32812 0.75-0.32812 0.32422 0 0.60156 0.11328 0.82812 0.34375 0.21875 0.23828 0.32812 0.66016 0.32812 1.2656 0 0.58203-0.097656 1.0195-0.29688 1.3125-0.20703 0.30078-0.50391 0.45312-0.89062 0.45312-0.25 0-0.45703-0.070312-0.625-0.20312-0.16406-0.13672-0.26953-0.33984-0.3125-0.60938l0.40625-0.046875c0.074219 0.35156 0.26172 0.53125 0.5625 0.53125 0.19922 0 0.375-0.10547 0.53125-0.3125 0.14844-0.21094 0.21875-0.53125 0.21875-0.96875zm-0.71875-1.4219c-0.1875 0-0.33594 0.070312-0.45312 0.21875-0.11328 0.15625-0.17188 0.33594-0.17188 0.54688 0 0.20703 0.058594 0.37891 0.17188 0.51562 0.11719 0.14453 0.27344 0.21875 0.46875 0.21875 0.17969 0 0.33594-0.070312 0.46875-0.20312 0.125-0.125 0.1875-0.29688 0.1875-0.51562s-0.0625-0.40625-0.1875-0.5625c-0.13281-0.14844-0.29688-0.21875-0.48438-0.21875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.4062 0h2.0625v3.2969h-0.4375v-2.9062h-1.625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.2969 0.46875c0.41797-0.35547 0.875-0.53125 1.375-0.53125s0.90625 0.15625 1.2188 0.46875 0.46875 0.72266 0.46875 1.2344c0 0.3125-0.0625 0.59766-0.1875 0.85938-0.13281 0.26953-0.32031 0.47656-0.5625 0.625-0.25 0.15625-0.55078 0.23438-0.90625 0.23438-0.375 0-0.67188-0.085937-0.89062-0.25-0.22656-0.15625-0.37891-0.40234-0.45312-0.73438l0.39062-0.10938c0.0625 0.23828 0.17188 0.41406 0.32812 0.53125 0.15625 0.125 0.36719 0.1875 0.625 0.1875 0.39844 0 0.69922-0.125 0.90625-0.375 0.19922-0.24219 0.29688-0.55859 0.29688-0.95312 0-0.29297-0.046875-0.53906-0.14062-0.73438-0.10156-0.1875-0.25-0.33594-0.4375-0.4375-0.19531-0.09375-0.41016-0.14062-0.64062-0.14062-0.34375 0-0.66406 0.10938-0.96875 0.32812v0.625h0.98438v0.39062h-1.4062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.2188 1.75c-0.20703-0.0625-0.35938-0.16797-0.45312-0.3125-0.10156-0.13672-0.15625-0.29688-0.15625-0.48438 0-0.17969 0.046875-0.34375 0.14062-0.5 0.085938-0.15625 0.21484-0.27344 0.39062-0.34375 0.16797-0.074219 0.39844-0.10938 0.6875-0.10938h1.2656v3.2969h-1.2344c-0.40625 0-0.6875-0.089844-0.84375-0.26562-0.16406-0.16797-0.25-0.35938-0.25-0.57812 0-0.14844 0.039063-0.28125 0.10938-0.40625 0.074219-0.11719 0.1875-0.21484 0.34375-0.29688zm1.4375 0.17188h-0.71875c-0.14453 0-0.26562 0.00391-0.35938 0.015625-0.10156 0.019531-0.19141 0.0625-0.26562 0.125-0.082031 0.070312-0.125 0.1875-0.125 0.34375s0.042969 0.26953 0.125 0.34375c0.074219 0.070312 0.16797 0.11328 0.28125 0.125 0.10547 0.019531 0.24219 0.03125 0.40625 0.03125h0.65625zm0-1.5312h-0.8125c-0.30078 0-0.50781 0.046875-0.625 0.14062-0.11328 0.10156-0.17188 0.24219-0.17188 0.42188 0 0.1875 0.0625 0.32812 0.1875 0.42188 0.125 0.10156 0.34375 0.15625 0.65625 0.15625h0.76562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.9375 1.0625c0-0.40625 0.085938-0.69922 0.25-0.875 0.15625-0.16797 0.38281-0.25 0.67188-0.25 0.30469 0 0.52734 0.082031 0.67188 0.25 0.14844 0.16406 0.21875 0.41406 0.21875 0.75l-0.39062 0.0625c0-0.21875-0.039063-0.38672-0.125-0.5-0.082031-0.10547-0.20703-0.15625-0.375-0.15625-0.14453 0-0.25391 0.03125-0.32812 0.09375-0.070312 0.070312-0.11328 0.15625-0.125 0.25-0.019531 0.09375-0.03125 0.20703-0.03125 0.34375v2.2656h-0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.875 1.9219h0.45312v0.46875h-0.45312zm0-1.9219h0.45312v0.46875h-0.45312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.75 1.7812c-0.40625-0.125-0.60938-0.40625-0.60938-0.84375 0-0.28125 0.10547-0.52344 0.3125-0.71875 0.19922-0.1875 0.45312-0.28125 0.76562-0.28125 0.32422 0 0.58984 0.09375 0.79688 0.28125 0.19922 0.19531 0.29688 0.44141 0.29688 0.73438 0 0.20703-0.054688 0.39062-0.17188 0.54688-0.11328 0.15625-0.26953 0.25-0.46875 0.28125v0.015625c0.33594 0.10156 0.5 0.32812 0.5 0.67188 0 0.23828-0.082031 0.4375-0.25 0.59375-0.17578 0.16406-0.40625 0.25-0.6875 0.25-0.28906 0-0.52344-0.085938-0.70312-0.25-0.17578-0.16797-0.26562-0.37109-0.26562-0.60938 0-0.32422 0.16406-0.54297 0.48438-0.65625zm0.46875 0.15625c-0.15625 0-0.28125 0.046875-0.375 0.14062-0.10156 0.10156-0.15625 0.22656-0.15625 0.375 0 0.14453 0.054688 0.26953 0.15625 0.375 0.10547 0.10156 0.23047 0.15625 0.375 0.15625 0.15625 0 0.28906-0.054687 0.39062-0.15625 0.09375-0.09375 0.14062-0.21484 0.14062-0.35938 0-0.15625-0.046875-0.28906-0.14062-0.39062-0.10156-0.09375-0.23438-0.14062-0.39062-0.14062zm0-1.6562c-0.1875 0-0.34375 0.054688-0.46875 0.17188-0.13281 0.125-0.20312 0.28516-0.20312 0.48438 0 0.19531 0.070313 0.35938 0.20312 0.48438 0.125 0.125 0.28906 0.1875 0.48438 0.1875 0.1875 0 0.34375-0.070313 0.46875-0.20312 0.125-0.125 0.1875-0.27734 0.1875-0.45312 0-0.19922-0.0625-0.35938-0.1875-0.48438s-0.28516-0.1875-0.48438-0.1875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.2812 3.2969 0.95312-3.4062h0.32812l-0.95312 3.4062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.9531 1.5469c0.085937-0.125 0.19531-0.23047 0.32812-0.3125 0.13672-0.074219 0.28906-0.10938 0.45312-0.10938 0.27344 0 0.5 0.097656 0.6875 0.29688 0.1875 0.19531 0.28125 0.45703 0.28125 0.78125 0 0.32031-0.09375 0.58594-0.28125 0.79688-0.19531 0.20703-0.44531 0.3125-0.75 0.3125-0.30078 0-0.5625-0.12109-0.78125-0.35938-0.22656-0.24219-0.34375-0.65234-0.34375-1.2344 0-0.59375 0.10547-1.043 0.3125-1.3438 0.19922-0.29297 0.48438-0.4375 0.85938-0.4375 0.25 0 0.46094 0.066406 0.625 0.20312 0.16797 0.13281 0.26562 0.34375 0.29688 0.625l-0.375 0.03125c-0.0625-0.34375-0.24219-0.51562-0.54688-0.51562-0.25 0-0.44141 0.10938-0.57812 0.32812-0.13281 0.22656-0.20312 0.53906-0.20312 0.9375zm0.6875-0.078125c-0.19531 0-0.35156 0.066406-0.46875 0.20312-0.125 0.14453-0.1875 0.32812-0.1875 0.54688s0.0625 0.39844 0.1875 0.54688c0.11719 0.14453 0.26562 0.21875 0.45312 0.21875s0.35156-0.078125 0.48438-0.23438c0.125-0.15625 0.1875-0.34375 0.1875-0.5625 0-0.21094-0.0625-0.38281-0.1875-0.51562-0.13281-0.13672-0.28906-0.20312-0.46875-0.20312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.3594 2.9375c0.32422-0.35547 0.60547-0.79297 0.84375-1.3125 0.24219-0.52344 0.38281-1.0625 0.42188-1.625h0.40625c-0.007812 0.44531-0.11719 0.9375-0.32812 1.4688-0.20703 0.53906-0.47656 1.0039-0.8125 1.3906h1.6094v0.39062h-2.1406z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.3281 0h2.1875c0 0.1875-0.0625 0.375-0.1875 0.5625-0.13281 0.1875-0.37891 0.42578-0.73438 0.71875-0.21875 0.17578-0.41016 0.35938-0.57812 0.54688-0.17578 0.1875-0.26562 0.37891-0.26562 0.57812 0 0.16406 0.0625 0.30078 0.1875 0.40625 0.11719 0.11328 0.26172 0.17188 0.4375 0.17188 0.17969 0 0.32812-0.058594 0.45312-0.17188 0.125-0.11719 0.1875-0.28125 0.1875-0.5l0.42188 0.046875c-0.03125 0.3125-0.14062 0.54688-0.32812 0.70312-0.19531 0.16406-0.44531 0.25-0.75 0.25-0.32031 0-0.57031-0.089844-0.75-0.26562-0.17578-0.17969-0.26562-0.39844-0.26562-0.65625 0-0.21094 0.078125-0.42188 0.23438-0.64062 0.14844-0.21875 0.44922-0.50781 0.90625-0.85938 0.23047-0.19922 0.38672-0.36719 0.46875-0.5h-1.625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.8594-0.96875h0.29688c0.25 0.32422 0.44922 0.67188 0.59375 1.0469 0.13672 0.375 0.20312 0.74219 0.20312 1.1094 0 0.42578-0.070313 0.81641-0.21875 1.1719-0.15625 0.35156-0.34766 0.6875-0.57812 1h-0.29688c0.27344-0.4375 0.45312-0.82422 0.54688-1.1562 0.085938-0.33594 0.125-0.66797 0.125-1 0-0.73047-0.22266-1.4531-0.67188-2.1719z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.4219 0.21875 0.28125-0.26562c0.49219 0.40625 0.8125 0.94531 0.96875 1.625v-1.875h0.35938v1.7812c0.10547-0.46875 0.46094-0.96484 1.0625-1.4844l0.25 0.28125c-0.53125 0.44531-0.87891 0.94531-1.0469 1.5h0.75v0.32812h-1.0156v0.67188h0.4375c0.085938-0.21094 0.1875-0.40625 0.3125-0.59375l0.35938 0.17188c-0.28906 0.3125-0.44531 0.72266-0.46875 1.2344l-0.34375-0.10938c0-0.125 0.015625-0.25 0.046875-0.375h-0.34375v0.75h-0.35938v-0.75h-0.82812v-0.32812h0.82812v-0.67188h-1.0625v-0.32812h0.78125c-0.16406-0.66797-0.48828-1.1875-0.96875-1.5625zm2.5 1.2188 0.3125-0.20312c0.0625 0.23828 0.16406 0.42969 0.29688 0.57812v-2.1094h0.35938v1.9531c0.074219-0.21875 0.25781-0.49219 0.54688-0.8125l0.28125 0.21875c-0.44531 0.46875-0.72266 0.98828-0.82812 1.5625h0.625v0.34375h-0.625v0.89062h-0.35938v-0.89062h-0.5v-0.34375h0.5v-0.45312l-0.046875 0.03125c-0.15625-0.09375-0.34375-0.35156-0.5625-0.76562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.0469 3.3594c-0.25-0.32422-0.44531-0.67188-0.59375-1.0469-0.14453-0.375-0.21875-0.75-0.21875-1.125 0-0.41797 0.078125-0.80859 0.23438-1.1719 0.15625-0.35156 0.35156-0.67969 0.57812-0.98438h0.28125c-0.25781 0.4375-0.4375 0.82031-0.53125 1.1406-0.09375 0.33203-0.14062 0.67188-0.14062 1.0156 0 0.72656 0.22656 1.4531 0.67188 2.1719z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.9062 3.0625 0.32812-0.14062c0.054687 0.25781 0.125 0.46875 0.21875 0.625l-0.34375 0.14062c-0.082031-0.16797-0.14844-0.375-0.20312-0.625zm1.5625 0.14062 0.14062-0.42188c0.40625 0.22656 0.875 0.36719 1.4062 0.42188l-0.14062 0.4375c-0.59375-0.125-1.0625-0.27344-1.4062-0.4375zm-1.0469-0.32812 0.3125-0.125c0.0625 0.25 0.13672 0.45312 0.21875 0.60938l-0.32812 0.14062c-0.082031-0.16797-0.14844-0.375-0.20312-0.625zm-0.75-0.57812c0.41797-0.66797 0.89062-1.1992 1.4219-1.5938 0.53125-0.38672 1.1719-0.68359 1.9219-0.89062l0.21875 0.4375c-0.78125 0.17578-1.4297 0.45312-1.9531 0.82812-0.51953 0.38281-0.9375 0.89062-1.25 1.5156zm2.2344-0.26562 0.15625-0.4375c0.35547 0.25 0.82031 0.40625 1.3906 0.46875l-0.15625 0.42188c-0.5625-0.10547-1.0234-0.25781-1.3906-0.45312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.6406 2.5781 0.59375-1.3125 0.34375 0.15625-0.375 0.85938 0.78125-0.14062-0.40625-1.8438 0.35938-0.078125 0.42188 1.8438 0.90625-0.17188 0.078125 0.375-0.90625 0.17188 0.14062 0.65625-0.375 0.0625-0.14062-0.65625-1.2031 0.23438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.8594 3.8594c-0.125 0-0.23438-0.054687-0.32812-0.15625-0.10156-0.09375-0.15625-0.20312-0.15625-0.32812 0-0.13672 0.054688-0.25781 0.15625-0.35938 0.09375-0.09375 0.20312-0.14062 0.32812-0.14062 0.13672 0 0.25781 0.046875 0.35938 0.14062 0.09375 0.10156 0.14062 0.22266 0.14062 0.35938 0 0.125-0.046875 0.23438-0.14062 0.32812-0.10156 0.10156-0.22266 0.15625-0.35938 0.15625zm0-0.67188c-0.050781 0-0.09375 0.015625-0.125 0.046875-0.039063 0.03125-0.0625 0.078125-0.0625 0.14062 0 0.050781 0.023437 0.09375 0.0625 0.125 0.03125 0.039062 0.074219 0.0625 0.125 0.0625 0.0625 0 0.10938-0.023438 0.14062-0.0625 0.03125-0.03125 0.046875-0.074219 0.046875-0.125 0-0.0625-0.015625-0.10938-0.046875-0.14062s-0.078125-0.046875-0.14062-0.046875zm2.0156 0.32812c0.09375-0.69922 0.25-1.3867 0.46875-2.0625 0.21875-0.66797 0.48047-1.2031 0.78125-1.6094l0.375 0.26562c-0.32031 0.44531-0.58594 0.98438-0.79688 1.6094-0.21875 0.63281-0.35156 1.2812-0.40625 1.9375zm-2.2344-3.4219 0.4375-0.10938c0.054687 0.48828 0.18359 1.0508 0.39062 1.6875 0.21094 0.63281 0.46484 1.2266 0.76562 1.7812l-0.39062 0.17188c-0.63281-1.3242-1.0352-2.5-1.2031-3.5312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.0625 2.7969 0.25-0.35938c0.375 0.3125 0.8125 0.53125 1.3125 0.65625l-0.25 0.375c-0.53125-0.1875-0.96875-0.41406-1.3125-0.67188zm-2.0625-0.46875c0.53125-0.78125 1.0586-1.3438 1.5781-1.6875 0.51172-0.34375 1.1016-0.60938 1.7656-0.79688l0.25 0.42188c-0.8125 0.17578-1.4688 0.45703-1.9688 0.84375-0.5 0.38281-0.92969 0.89062-1.2969 1.5156z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.375-0.96875h0.29688c0.25 0.32422 0.44922 0.67188 0.59375 1.0469 0.13672 0.375 0.20312 0.74219 0.20312 1.1094 0 0.42578-0.070312 0.81641-0.21875 1.1719-0.15625 0.35156-0.34766 0.6875-0.57812 1h-0.29688c0.27344-0.4375 0.45312-0.82422 0.54688-1.1562 0.085937-0.33594 0.125-0.66797 0.125-1 0-0.73047-0.22266-1.4531-0.67188-2.1719z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.45312 3.3594c-0.25-0.32422-0.44531-0.67188-0.59375-1.0469-0.14453-0.375-0.21875-0.75-0.21875-1.125 0-0.41797 0.078125-0.80859 0.23438-1.1719 0.15625-0.35156 0.35156-0.67969 0.57812-0.98438h0.28125c-0.25781 0.4375-0.4375 0.82031-0.53125 1.1406-0.09375 0.33203-0.14062 0.67188-0.14062 1.0156 0 0.72656 0.22656 1.4531 0.67188 2.1719z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.5156 0.90625h0.70312l0.1875-0.96875h0.34375l-0.20312 0.96875h0.71875l0.1875-0.96875h0.34375l-0.20312 0.96875h0.39062v0.32812h-0.45312l-0.17188 0.82812h0.625v0.32812h-0.6875l-0.20312 0.96875h-0.32812l0.1875-0.96875h-0.70312l-0.20312 0.96875h-0.32812l0.1875-0.96875h-0.39062v-0.32812h0.46875l0.15625-0.82812h-0.625zm0.79688 1.1562h0.71875l0.15625-0.82812h-0.70312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.8281 0h2.4688v3.2969h-2.3906v-0.39062h1.9531v-1h-1.8281v-0.39062h1.8281v-1.125h-2.0312zm0.70312 4.1562 0.5-0.64062h0.32812l-0.29688 0.64062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.4375 0.046875 0.14062-0.3125c0.25 0.10547 0.48438 0.24609 0.70312 0.42188 0.25-0.14844 0.51562-0.21875 0.79688-0.21875 0.46875 0 0.85156 0.16016 1.1406 0.48438 0.29297 0.32031 0.4375 0.73438 0.4375 1.2344 0 0.48828-0.14062 0.89453-0.42188 1.2188-0.28906 0.32031-0.67578 0.48438-1.1562 0.48438-0.45703 0-0.83203-0.15625-1.125-0.46875-0.30078-0.3125-0.45312-0.72656-0.45312-1.2344 0-0.54297 0.16797-0.97656 0.5-1.2969-0.1875-0.13672-0.375-0.24219-0.5625-0.3125zm0.90625 0.54688c-0.25781 0.23828-0.39062 0.59375-0.39062 1.0625 0 0.40625 0.10547 0.72656 0.3125 0.96875 0.21094 0.23828 0.48047 0.35938 0.8125 0.35938 0.33594 0 0.60547-0.11719 0.8125-0.34375 0.21094-0.23047 0.3125-0.55859 0.3125-0.98438 0-0.42969-0.10156-0.76172-0.3125-1-0.20703-0.23047-0.47656-0.34375-0.8125-0.34375-0.16406 0-0.3125 0.03125-0.4375 0.09375 0.14844 0.09375 0.28906 0.15625 0.42188 0.1875l-0.09375 0.3125c-0.26953-0.074219-0.47656-0.17969-0.625-0.3125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.3125 1.5938h0.73438v-1.9062h0.34375v4.1875h-0.34375v-1.9219h-0.73438zm1.7344 0.29688c0-0.38672 0.10547-0.71875 0.3125-1 0.21094-0.27344 0.45312-0.40625 0.73438-0.40625 0.29297 0 0.53906 0.13281 0.73438 0.40625 0.19922 0.26953 0.29688 0.60156 0.29688 1 0 0.41406-0.09375 0.75391-0.28125 1.0156-0.19531 0.25781-0.44531 0.39062-0.75 0.39062-0.28125 0-0.52344-0.14062-0.73438-0.42188-0.20703-0.27344-0.3125-0.60156-0.3125-0.98438zm0.35938 0c0 0.28906 0.070312 0.53516 0.20312 0.73438 0.13672 0.20703 0.29688 0.3125 0.48438 0.3125s0.35156-0.10547 0.48438-0.3125c0.13672-0.19922 0.20312-0.44531 0.20312-0.73438 0-0.29297-0.066406-0.54297-0.20312-0.75-0.13281-0.19922-0.29688-0.29688-0.48438-0.29688s-0.34766 0.097656-0.48438 0.29688c-0.13281 0.20703-0.20312 0.45703-0.20312 0.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.1719-0.3125h0.34375v4.1875h-0.34375zm1.1875 2.2031c0-0.4375 0.11719-0.80469 0.34375-1.0938 0.21875-0.28125 0.49609-0.42188 0.82812-0.42188 0.36719 0 0.65625 0.13281 0.875 0.40625 0.21875 0.28125 0.32812 0.64844 0.32812 1.1094 0 0.46875-0.10938 0.83203-0.32812 1.0938-0.21875 0.26953-0.50781 0.40625-0.875 0.40625-0.33203 0-0.60938-0.14062-0.82812-0.42188-0.22656-0.27344-0.34375-0.63281-0.34375-1.0781zm0.39062 0c0 0.32031 0.074219 0.59375 0.21875 0.8125 0.14844 0.21875 0.33594 0.32812 0.5625 0.32812 0.24219 0 0.4375-0.11719 0.59375-0.34375 0.14844-0.21875 0.21875-0.48438 0.21875-0.79688 0-0.30469-0.070312-0.57031-0.21875-0.79688-0.15625-0.23047-0.35156-0.34375-0.59375-0.34375-0.22656 0-0.41406 0.10938-0.5625 0.32812-0.14453 0.22656-0.21875 0.5-0.21875 0.8125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.1875-0.3125h0.35938v4.1875h-0.35938zm1 1.1875c0.36719-0.0625 0.82422-0.12109 1.375-0.17188 0.55469-0.042969 0.96484-0.0625 1.2344-0.0625v2.7031h-2.4062v-0.35938h2.0469v-0.70312h-1.9531v-0.375h1.9531v-0.875c-0.84375 0.019531-1.5938 0.082031-2.25 0.1875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.1875 1.4375h0.35938v2.4531h-0.35938zm0.70312 0.015625h0.34375v0.96875h0.625v0.35938h-0.625v1h-0.34375zm1.125 1.1562c0-0.27344 0.09375-0.5 0.28125-0.6875 0.1875-0.17969 0.43359-0.26562 0.73438-0.26562 0.30469 0 0.54688 0.085938 0.73438 0.26562 0.17969 0.17578 0.26562 0.39844 0.26562 0.67188 0 0.28125-0.09375 0.50781-0.28125 0.6875-0.19531 0.17578-0.4375 0.26562-0.71875 0.26562-0.30078 0-0.54688-0.09375-0.73438-0.28125-0.1875-0.17969-0.28125-0.39844-0.28125-0.65625zm0.34375 0c0 0.15625 0.070313 0.28906 0.20312 0.40625 0.125 0.125 0.28125 0.1875 0.46875 0.1875 0.17969 0 0.33594-0.058594 0.46875-0.17188 0.125-0.11719 0.1875-0.25781 0.1875-0.42188 0-0.16797-0.0625-0.3125-0.1875-0.4375-0.13281-0.11719-0.28906-0.17188-0.46875-0.17188-0.1875 0-0.34375 0.054688-0.46875 0.17188-0.13281 0.125-0.20312 0.26953-0.20312 0.4375zm-1.8281-2.8906v1.1406h2.6719v0.35938h-3.0156v-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.4219 2.8438c-0.13281-0.24219-0.37891-0.48438-0.73438-0.73438-0.35156-0.25-0.70312-0.41797-1.0469-0.5 0.14844-0.125 0.24219-0.24609 0.28125-0.35938 0.30469 0.11328 0.61719 0.28516 0.9375 0.51562 0.32422 0.22656 0.57031 0.45703 0.73438 0.6875 0.375-0.58594 0.89844-1 1.5625-1.25 0.074219 0.125 0.15625 0.22266 0.25 0.29688-0.51953 0.1875-0.92578 0.45312-1.2188 0.79688-0.30078 0.34375-0.45312 0.71875-0.45312 1.125l-0.5-0.09375c0.0625-0.09375 0.125-0.25781 0.1875-0.48438zm-1.9219-2.6094h4.0781v0.375h-4.0781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-57"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.7812 3.3438c-0.00781-0.79297 0.078125-1.625 0.26562-2.5 0.074219 0.007812 0.21484 0.019531 0.42188 0.03125-0.070312 0.25-0.14062 0.58203-0.20312 1 1.2617-0.13672 2.0703-0.21094 2.4219-0.21875l0.09375 0.4375c-0.59375 0-1.4414 0.039062-2.5469 0.125-0.039063 0.3125-0.054687 0.5625-0.046875 0.75h2.5v0.375zm-0.5625-3.25h4.0625v0.375h-1.8438v0.98438h-0.34375v-0.98438h-1.875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.1875-0.3125h0.35938v4.1875h-0.35938zm3.5312 0.46875v1.9844h-2.0312v0.90625h2.0312v0.35938h-2.3906v-1.6094h2.0156v-1.2656c-0.85156 0.039062-1.6406 0.14844-2.3594 0.32812l-0.015625-0.375c0.71094-0.17969 1.625-0.28906 2.75-0.32812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.8281-0.32812v2.2031h1.375v0.35938h-1.375v1.6406h-0.35938v-4.2031zm1.2344 0.70312c0.39844 0.35156 0.71875 0.83594 0.96875 1.4531 0.25-0.64844 0.60156-1.1797 1.0469-1.5938 0.11719 0.17578 0.21875 0.28906 0.3125 0.34375-0.35156 0.22656-0.63281 0.57031-0.84375 1.0312-0.21875 0.46875-0.32812 0.89062-0.32812 1.2656l0.015625 0.375v0.23438l-0.48438-0.046875c0.09375-0.1875 0.14062-0.52344 0.14062-1 0-0.0625-0.050781-0.21094-0.15625-0.4375-0.10156-0.21875-0.20312-0.40625-0.29688-0.5625-0.10156-0.14844-0.21094-0.28125-0.32812-0.40625-0.11328-0.125-0.23438-0.23047-0.35938-0.3125 0.14844-0.09375 0.25-0.21094 0.3125-0.34375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.8281 2.9688c0-0.19922 0.14844-0.375 0.4375-0.53125 0.29297-0.14844 0.65234-0.21875 1.0781-0.21875 0.46094 0 0.82812 0.066406 1.1094 0.20312 0.28125 0.14453 0.42188 0.32812 0.42188 0.54688 0 0.20703-0.14453 0.38281-0.4375 0.53125-0.30078 0.14453-0.66406 0.21875-1.0938 0.21875-0.41406 0-0.76953-0.074219-1.0625-0.21875-0.30078-0.14844-0.45312-0.32422-0.45312-0.53125zm0.4375 0c0 0.11328 0.10547 0.20703 0.3125 0.28125 0.19922 0.082031 0.45312 0.125 0.76562 0.125s0.57422-0.042969 0.78125-0.125c0.21094-0.074219 0.3125-0.16797 0.3125-0.28125 0-0.11719-0.10156-0.21484-0.3125-0.29688-0.20703-0.074219-0.46875-0.10938-0.78125-0.10938s-0.56641 0.035156-0.76562 0.10938c-0.20703 0.082031-0.3125 0.17969-0.3125 0.29688zm-0.85938-1.2812h1.7656v-0.3125h0.35938v0.3125h1.7656v0.35938h-3.8906zm0.53125-0.39062v-0.92188h2.5v-0.29688h-2.5625v-0.35938h2.9219v1.0156h-2.5v0.20312h2.5156v0.35938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.1875-0.3125h0.35938v4.1875h-0.35938zm1.1719 0.875c0.46094 0.34375 0.82812 0.82812 1.1094 1.4531 0.28125-0.65625 0.67188-1.1875 1.1719-1.5938 0.125 0.15625 0.23047 0.25391 0.3125 0.29688-0.38281 0.23828-0.69531 0.58594-0.9375 1.0469-0.23828 0.46875-0.35938 0.88281-0.35938 1.25 0 0.28906 0.011719 0.48438 0.03125 0.57812l-0.53125-0.046875c0.0625-0.125 0.10547-0.24609 0.125-0.35938 0.011719-0.10547 0.015625-0.30859 0.015625-0.60938 0-0.054687-0.039063-0.16797-0.125-0.34375-0.082031-0.17969-0.16016-0.32812-0.23438-0.45312-0.082031-0.125-0.17188-0.24609-0.26562-0.35938-0.09375-0.10547-0.19141-0.20312-0.29688-0.29688-0.10156-0.09375-0.21094-0.18359-0.32812-0.26562 0.14844-0.085937 0.25-0.18359 0.3125-0.29688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.3125 2.4688h0.73438v-1.0312h0.34375v2.4219h-0.34375v-1.0312h-0.73438zm3.6719-1.0312 0.23438 0.29688c-0.36328 0.125-0.70312 0.33203-1.0156 0.625-0.3125 0.28906-0.51562 0.58203-0.60938 0.875h1.4844v0.35938h-1.9844c0.085938-0.46875 0.29688-0.89844 0.64062-1.2812 0.33594-0.38672 0.75-0.67969 1.25-0.875zm-3.0312-0.92188c0-0.24219 0.13281-0.4375 0.39062-0.59375 0.25-0.15625 0.57812-0.23438 0.98438-0.23438 0.41797 0 0.75781 0.074219 1.0156 0.21875 0.25 0.14453 0.375 0.34766 0.375 0.60938 0 0.22656-0.12891 0.42578-0.39062 0.59375-0.25781 0.16406-0.59375 0.25-1 0.25s-0.73438-0.078125-0.98438-0.23438c-0.25781-0.15625-0.39062-0.35938-0.39062-0.60938zm0.40625-0.015625c0 0.14453 0.089844 0.25781 0.26562 0.34375 0.17969 0.09375 0.40625 0.14062 0.6875 0.14062 0.30469 0 0.54688-0.046875 0.73438-0.14062 0.17969-0.085938 0.26562-0.19531 0.26562-0.32812 0-0.13672-0.085938-0.25-0.26562-0.34375-0.1875-0.09375-0.42969-0.14062-0.73438-0.14062-0.28125 0-0.50781 0.039062-0.6875 0.125-0.17578 0.09375-0.26562 0.20703-0.26562 0.34375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.3125 2.5h0.73438v-1.0625h0.34375v2.4375h-0.34375v-1.0156h-0.73438zm3.4531 0.92188v-1.2656c-0.48828-0.011719-1.1914 0.035156-2.1094 0.14062v-0.34375c0.76172-0.09375 1.5859-0.14844 2.4688-0.15625v1.625zm-2.375-3.7031v0.15625h1.8906v-0.15625h0.34375v1.5781h-2.5781v-1.5781zm0 1.2188h1.8906v-0.70312h-1.8906z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.2344 1.5469h1.75v-1.8438h0.35938v1.8438h1.7656v0.35938h-2.8125c-0.13281 0.71875-0.20312 1.1602-0.20312 1.3281h2.7031v0.35938h-3.1094c0.011719-0.28125 0.089844-0.84375 0.23438-1.6875h-0.6875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.1875 1.4219h0.35938v0.70312h0.92188v0.34375h-0.92188v0.34375h0.92188v0.35938h-0.92188v0.70312h-0.35938zm1.6562 1.1875c0-0.28125 0.10156-0.52344 0.29688-0.71875 0.19922-0.1875 0.45312-0.28125 0.76562-0.28125 0.32422 0 0.58594 0.09375 0.78125 0.28125 0.1875 0.1875 0.28125 0.42578 0.28125 0.71875 0 0.28125-0.097656 0.51562-0.29688 0.70312-0.19531 0.1875-0.45312 0.28125-0.76562 0.28125s-0.56641-0.09375-0.76562-0.28125c-0.19531-0.1875-0.29688-0.42188-0.29688-0.70312zm0.34375 0c0 0.17578 0.074219 0.32812 0.21875 0.45312 0.13672 0.125 0.30469 0.1875 0.5 0.1875 0.19922 0 0.36719-0.0625 0.5-0.1875 0.13672-0.125 0.20312-0.27734 0.20312-0.45312 0-0.17969-0.066406-0.32812-0.20312-0.45312-0.13281-0.125-0.30078-0.1875-0.5-0.1875-0.19531 0-0.36328 0.0625-0.5 0.1875-0.14453 0.125-0.21875 0.27344-0.21875 0.45312zm-2.0156-2.1094c0-0.26172 0.14844-0.46094 0.4375-0.59375 0.29297-0.14453 0.66797-0.21875 1.125-0.21875 0.46875 0 0.85156 0.074219 1.1406 0.21875 0.28125 0.14453 0.42188 0.34766 0.42188 0.60938 0 0.25-0.14844 0.44531-0.45312 0.59375-0.3125 0.15625-0.67969 0.23438-1.1094 0.23438-0.45703 0-0.83203-0.074219-1.125-0.21875-0.28906-0.14844-0.4375-0.35547-0.4375-0.625zm0.39062 0c0 0.13281 0.11719 0.25 0.34375 0.34375 0.21875 0.09375 0.49219 0.14062 0.8125 0.14062 0.32422 0 0.60547-0.042969 0.84375-0.125 0.24219-0.085937 0.35938-0.19922 0.35938-0.34375 0-0.13672-0.125-0.25-0.375-0.34375s-0.51953-0.14062-0.8125-0.14062c-0.32031 0-0.59766 0.046875-0.82812 0.14062-0.22656 0.09375-0.34375 0.20312-0.34375 0.32812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.25 1.5312h3.8906v0.32812h-1.7656v0.32812h1.3125v1.4531h-2.9219v-0.35938h2.5625v-0.73438h-2.6094v-0.35938h1.2969v-0.32812h-1.7656zm0.39062-1.0312c0-0.26172 0.14844-0.46094 0.4375-0.59375 0.28125-0.14453 0.65234-0.21875 1.1094-0.21875 0.48047 0 0.85938 0.074219 1.1406 0.21875 0.28125 0.14453 0.42188 0.34766 0.42188 0.60938 0 0.25-0.14844 0.44531-0.45312 0.59375-0.3125 0.15625-0.67969 0.23438-1.1094 0.23438-0.45703 0-0.82812-0.074219-1.1094-0.21875-0.28906-0.14844-0.4375-0.35547-0.4375-0.625zm1.5 0.48438c0.35547 0 0.65234-0.042969 0.89062-0.125 0.23047-0.085937 0.34375-0.19922 0.34375-0.34375 0-0.13672-0.125-0.25-0.375-0.34375s-0.51953-0.14062-0.8125-0.14062c-0.32031 0-0.59766 0.046875-0.82812 0.14062-0.22656 0.09375-0.34375 0.20703-0.34375 0.34375 0 0.125 0.10938 0.23438 0.32812 0.32812s0.48438 0.14062 0.79688 0.14062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.1875-0.3125h0.35938v1.9531h0.5625v-1.7031h0.35938v3.7188h-0.35938v-1.6562h-0.5625v1.875h-0.35938zm1.7656 3.1875h1.5625v-2.125c-0.47656 0-1.0859 0.054688-1.8281 0.17188v-0.35938c0.6875-0.10547 1.418-0.17188 2.1875-0.20312v2.875h-1.9219z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.3438 0.125h4.0625v0.35938h-1.8438v0.73438h1.2812v1.3125h-2.4531v0.57812h2.4531v0.375h-2.8281v-1.3125h2.4531v-0.57812h-2.5625v-0.375h1.3125v-0.73438h-1.875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.7969 1.125h2.9375v2.1875h-2.8906v-0.35938h2.5156v-0.54688h-2.375v-0.375h2.375v-0.53125h-2.5625zm-0.54688-0.89062h4.0781v0.375h-4.0781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.8281-0.3125v4.2031h-0.35938v-4.2031zm0.85938 0.25v1.6562h0.60938v0.35938h-0.60938v1.8594h-0.35938v-3.875zm2.4219 0.25v2.0938h-1.375v0.85938h1.375v0.35938h-1.7344v-1.5781h1.375v-1.3594c-0.5 0.007812-1.0352 0.085938-1.6094 0.23438v-0.34375c0.54297-0.15625 1.1992-0.24609 1.9688-0.26562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.7344 2.9062h2.5625v-1.2812h-2.6094c-0.00781-0.10547-0.00781-0.22656 0-0.35938h2.9688v2h-2.9219zm-0.60938-2.7188h4.0781v0.375h-4.0781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.8281 0.76562v3.1094h-0.35938v-3.1094zm0.78125 0.25v1.4531h0.79688v0.34375h-0.79688v0.98438h-0.35938v-2.7812zm1.3438 1.7969c-0.070313-0.21875-0.21875-0.46094-0.4375-0.71875-0.21875-0.26172-0.44141-0.45312-0.67188-0.57812 0.125-0.054687 0.23047-0.15234 0.3125-0.29688 0.35547 0.23828 0.68359 0.60156 0.98438 1.0938 0.19922-0.4375 0.52344-0.82031 0.96875-1.1406 0.085937 0.125 0.17969 0.22266 0.28125 0.29688-0.26953 0.17578-0.5 0.38281-0.6875 0.625-0.19531 0.23828-0.32031 0.45703-0.375 0.65625-0.050781 0.20703-0.078125 0.47266-0.078125 0.79688l-0.45312-0.046875c0.042969-0.0625 0.078125-0.19531 0.10938-0.39062 0.03125-0.1875 0.046875-0.28906 0.046875-0.29688zm-2.4844-3.0312h3.0625v1.4062h-0.35938v-1.0312h-2.7031z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.8281-0.32812v1.9219h1.0312v0.35938h-1.0312v1.9219h-0.35938v-4.2031zm0.85938 0.98438c0.34375-0.054688 0.77734-0.10156 1.2969-0.14062 0.51172-0.042969 0.89062-0.0625 1.1406-0.0625v2.875h-2.2188v-0.35938h1.8594v-0.8125h-1.7656v-0.35938h1.7656v-0.98438c-0.53906 0-1.2344 0.0625-2.0781 0.1875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.9844 3.3438h1.3594v0.35938h-1.3594zm-1.0469-1.0781 0.34375-0.35938c0.60547 0.13281 1.0703 0.375 1.3906 0.71875 0.35547-0.36719 0.82422-0.60938 1.4062-0.73438 0.11719 0.17578 0.21094 0.28906 0.28125 0.34375-0.63281 0.11328-1.0664 0.29688-1.2969 0.54688h1.25v0.35938h-3.2969v-0.35938h1.2656c-0.26953-0.26172-0.71875-0.43359-1.3438-0.51562zm-0.21875-0.8125h3.8906v0.35938h-3.8906zm0.39062-0.95312c0-0.26172 0.14844-0.46094 0.4375-0.59375 0.28125-0.14453 0.65234-0.21875 1.1094-0.21875 0.48047 0 0.85938 0.074219 1.1406 0.21875 0.28125 0.14453 0.42188 0.34766 0.42188 0.60938 0 0.25-0.14844 0.44531-0.45312 0.59375-0.3125 0.15625-0.67969 0.23438-1.1094 0.23438-0.45703 0-0.82812-0.074219-1.1094-0.21875-0.28906-0.14844-0.4375-0.35547-0.4375-0.625zm1.5 0.48438c0.35547 0 0.65234-0.042969 0.89062-0.125 0.23047-0.085937 0.34375-0.19922 0.34375-0.34375 0-0.13672-0.125-0.25-0.375-0.34375s-0.51953-0.14062-0.8125-0.14062c-0.32031 0-0.59766 0.046875-0.82812 0.14062-0.22656 0.09375-0.34375 0.20703-0.34375 0.34375 0 0.125 0.10938 0.23438 0.32812 0.32812s0.48438 0.14062 0.79688 0.14062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.2344 0c0.11719-0.019531 0.21484-0.03125 0.29688-0.03125 0.17969 0 0.30859 0.03125 0.39062 0.09375 0.085937 0.0625 0.13672 0.14062 0.15625 0.23438 0.011719 0.09375 0.015625 0.22656 0.015625 0.40625v1.375h0.29688v0.3125h-0.29688v0.59375l-0.40625 0.25v-0.84375h-0.40625v-0.3125h0.40625v-1.4062c0-0.11719-0.007812-0.19922-0.03125-0.25-0.03125-0.054687-0.09375-0.078125-0.1875-0.078125-0.0625 0-0.125 0.003906-0.1875 0.015625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.3906 1.0938h1.7969c-0.019531-0.26172-0.09375-0.46484-0.21875-0.60938-0.13281-0.13672-0.30469-0.20312-0.51562-0.20312-0.15625 0-0.28516 0.035156-0.39062 0.10938-0.10156 0.082031-0.17969 0.20703-0.23438 0.375l-0.42188-0.046875c0.074219-0.25 0.19922-0.44531 0.375-0.57812 0.17969-0.13672 0.40234-0.20312 0.67188-0.20312 0.36719 0 0.64844 0.10938 0.84375 0.32812 0.19922 0.22656 0.29688 0.53125 0.29688 0.90625s-0.09375 0.67578-0.28125 0.90625c-0.19531 0.23828-0.47266 0.35938-0.82812 0.35938-0.17578 0-0.34375-0.039062-0.5-0.10938-0.16406-0.074219-0.30469-0.20312-0.42188-0.39062-0.11328-0.1875-0.17188-0.46875-0.17188-0.84375zm0.42188 0.32812c0.023438 0.25 0.10156 0.42578 0.23438 0.53125 0.125 0.10156 0.27344 0.15625 0.4375 0.15625 0.1875 0 0.34375-0.0625 0.46875-0.1875s0.19922-0.29297 0.21875-0.5zm0.10938 1.9375 0.5-0.64062h0.32812l-0.29688 0.64062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.2969 3.2969 0.90625-3.2969h0.42188l0.71875 2.5938c0.03125 0.13281 0.054688 0.23828 0.0625 0.3125h0.015625l0.09375-0.39062 0.70312-2.5156h0.4375l0.875 3.2969h-0.4375l-0.51562-2.1562c-0.0625-0.29297-0.10156-0.5-0.125-0.625v-0.046875h-0.015625c-0.0625 0.28125-0.10938 0.48438-0.14062 0.60938l-0.625 2.2188h-0.53125l-0.46875-1.6719c-0.11328-0.40625-0.19531-0.79297-0.25-1.1562h-0.015625c-0.03125 0.17578-0.082031 0.41016-0.15625 0.70312l-0.51562 2.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.84375 0h0.4375v3.25h-0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.4062 0h0.40625v2.7188l0.9375-2.7188h0.375l0.92188 2.7656h0.015625v-2.7656h0.40625v3.25h-0.64062l-0.76562-2.2969c-0.082031-0.26172-0.12891-0.42188-0.14062-0.48438h-0.015625c-0.03125 0.125-0.082031 0.29688-0.15625 0.51562l-0.78125 2.2656h-0.5625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.34375 3.25h-1.2188c-0.1875 0-0.34766-0.011719-0.48438-0.03125-0.14453-0.023438-0.27344-0.074219-0.39062-0.15625-0.125-0.085938-0.21094-0.19531-0.26562-0.32812-0.0625-0.13672-0.09375-0.27734-0.09375-0.42188 0-0.30469 0.09375-0.54688 0.28125-0.73438 0.1875-0.17969 0.49609-0.26562 0.92188-0.26562h0.8125v-1.3125h0.4375zm-0.4375-1.5469h-0.82812c-0.5 0-0.75 0.19531-0.75 0.59375 0 0.125 0.03125 0.23438 0.09375 0.32812 0.0625 0.10156 0.14844 0.16406 0.25 0.1875 0.09375 0.03125 0.23438 0.046875 0.42188 0.046875h0.8125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.75 3.2969c-0.45703 0-0.82812-0.15625-1.1094-0.46875-0.28906-0.30469-0.4375-0.70312-0.4375-1.2031 0-0.51172 0.14844-0.92188 0.4375-1.2344 0.29297-0.30469 0.66406-0.45312 1.1094-0.45312 0.46094 0 0.82812 0.15625 1.1094 0.46875 0.28125 0.32031 0.42188 0.71094 0.42188 1.1719 0 0.53125-0.14062 0.94531-0.42188 1.25-0.28125 0.3125-0.64844 0.46875-1.1094 0.46875zm0-2.9844c-0.32031 0-0.58203 0.11328-0.78125 0.34375-0.20703 0.22656-0.31641 0.55078-0.32812 0.96875 0 0.41406 0.10547 0.73828 0.3125 0.96875 0.21094 0.22656 0.46875 0.34375 0.78125 0.34375 0.32422 0 0.58984-0.11719 0.79688-0.34375 0.21094-0.21875 0.3125-0.55859 0.3125-1.0156 0-0.375-0.097656-0.68359-0.29688-0.92188-0.20703-0.23047-0.47266-0.34375-0.79688-0.34375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.2031 0h0.54688c0.3125 0.50781 0.51172 0.82031 0.59375 0.9375 0.074219 0.11328 0.15625 0.21094 0.25 0.29688 0.085938 0.082031 0.16406 0.13281 0.23438 0.15625 0.074219 0.03125 0.17188 0.046875 0.29688 0.046875h0.5v-1.4375h0.42188v3.25h-1.4219c-0.19531 0-0.35938-0.015625-0.48438-0.046875-0.13281-0.023437-0.25-0.074219-0.34375-0.15625-0.10156-0.085937-0.17969-0.1875-0.23438-0.3125-0.0625-0.11719-0.09375-0.24219-0.09375-0.375 0-0.25 0.078125-0.44922 0.23438-0.59375 0.15625-0.14844 0.38281-0.24219 0.67188-0.28125v-0.015625c-0.21875-0.09375-0.42188-0.29297-0.60938-0.59375zm2.4219 1.8125h-0.92188c-0.1875 0-0.33203 0.015625-0.4375 0.046875-0.10156 0.03125-0.1875 0.09375-0.25 0.1875-0.070313 0.09375-0.10938 0.19531-0.10938 0.3125 0 0.14453 0.058594 0.26953 0.17188 0.375 0.10547 0.10156 0.28125 0.15625 0.53125 0.15625h1.0156z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.6562 2.8594h1.0781v-2.8594h0.42188v2.8594h1.0625v0.39062h-2.5625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3 0h0.46875l0.39062 0.98438h1.3438l0.34375-0.98438h0.45312l-1.2344 3.25h-0.45312zm0.98438 1.3281c0.26172 0.69531 0.41406 1.0938 0.45312 1.1875 0.03125 0.10156 0.070312 0.23438 0.10938 0.39062 0.042969-0.21875 0.10156-0.42188 0.17188-0.60938l0.35938-0.96875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.35938 3.25h-1.1094c-0.19531 0-0.36328-0.011719-0.5-0.03125-0.14453-0.023438-0.28125-0.074219-0.40625-0.15625-0.13281-0.074219-0.25-0.17969-0.34375-0.3125-0.09375-0.13672-0.16406-0.29297-0.21875-0.46875-0.0625-0.17969-0.09375-0.39062-0.09375-0.64062 0-0.48047 0.11719-0.875 0.34375-1.1875 0.23047-0.30469 0.62109-0.45312 1.1719-0.45312h1.1562zm-0.42188-2.8594h-0.70312c-0.13281 0-0.25391 0.003906-0.35938 0.015625-0.11328 0.019531-0.22656 0.066406-0.34375 0.14062-0.11328 0.082031-0.20703 0.21094-0.28125 0.39062-0.070312 0.17578-0.10938 0.41016-0.10938 0.70312 0 0.16406 0.015625 0.31641 0.046875 0.45312 0.023438 0.14453 0.074219 0.27344 0.15625 0.39062 0.074219 0.11328 0.16406 0.19531 0.26562 0.25 0.09375 0.0625 0.1875 0.097656 0.28125 0.10938 0.09375 0.00781 0.21484 0.015625 0.35938 0.015625h0.6875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.625 0h2.5469v0.40625l-1.6562 2.0625c0 0.00781-0.035156 0.054688-0.10938 0.14062-0.082031 0.09375-0.15625 0.17578-0.21875 0.25h1.7969v0.39062h-2.3125v-0.39062l1.8125-2.2344 0.1875-0.23438h-2.0469z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.8906 0h0.42188v1.5312h1.6875v-1.5312h0.42188v3.25h-0.42188v-1.3438h-1.6875v1.3438h-0.42188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.7656 0h2.4062v3.25h-2.3281v-0.39062h1.9062v-0.98438h-1.7812v-0.39062h1.7812v-1.0938h-1.9844z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.9688 0h0.51562l0.65625 0.92188c0.15625 0.22656 0.25781 0.37891 0.29688 0.45312 0-0.03125 0.32422-0.49219 0.96875-1.375h0.51562l-1.25 1.6875 1.0938 1.5625h-0.5l-0.6875-0.96875c-0.070313-0.10547-0.125-0.19531-0.15625-0.26562-0.0625 0.09375-0.36328 0.50391-0.90625 1.2344h-0.46875l1.1406-1.5312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0781 1.0312c0.09375-0.36719 0.26172-0.64062 0.5-0.82812 0.23047-0.17969 0.50781-0.26562 0.82812-0.26562 0.53125 0 0.91797 0.16406 1.1562 0.5 0.24219 0.33203 0.35938 0.73438 0.35938 1.2031 0 0.51953-0.14062 0.92578-0.42188 1.2188-0.28125 0.28906-0.64453 0.4375-1.0938 0.4375-0.3125 0-0.57812-0.085937-0.79688-0.25-0.22656-0.15625-0.38281-0.38672-0.46875-0.6875l0.40625-0.10938c0.074219 0.22656 0.18359 0.39844 0.32812 0.51562 0.14844 0.11328 0.32422 0.17188 0.53125 0.17188 0.35547 0 0.625-0.12109 0.8125-0.35938 0.17969-0.23047 0.26562-0.54297 0.26562-0.9375 0-0.44922-0.09375-0.78125-0.28125-1-0.19531-0.21875-0.44531-0.32812-0.75-0.32812-0.25 0-0.45312 0.066406-0.60938 0.20312-0.16406 0.13281-0.28125 0.34375-0.34375 0.625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.85938 0c0-0.1875 0.039063-0.32812 0.10938-0.42188 0.074219-0.10156 0.16406-0.17578 0.26562-0.21875l0.10938 0.17188c-0.16406 0.074219-0.25 0.23047-0.25 0.46875h0.21875v0.45312h-0.45312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.2656 2.2969c0.023437 0.20703 0.10156 0.35938 0.23438 0.45312 0.125 0.10156 0.30859 0.15625 0.54688 0.15625 0.23047 0 0.41406-0.042969 0.54688-0.125 0.13672-0.074219 0.20312-0.19531 0.20312-0.35938 0-0.13672-0.050781-0.24219-0.15625-0.3125-0.10156-0.0625-0.30469-0.13281-0.60938-0.20312-0.26953-0.054688-0.48828-0.10938-0.65625-0.17188-0.16406-0.0625-0.30469-0.16406-0.42188-0.29688-0.125-0.125-0.1875-0.29688-0.1875-0.51562 0-0.28125 0.10938-0.51562 0.32812-0.70312s0.50781-0.28125 0.85938-0.28125c0.46094 0 0.80469 0.10156 1.0312 0.3125 0.21875 0.20703 0.33594 0.47266 0.34375 0.79688l-0.40625 0.03125c-0.019531-0.26172-0.11719-0.45312-0.29688-0.57812-0.17578-0.11719-0.39453-0.17188-0.65625-0.17188-0.23828 0-0.42969 0.046875-0.57812 0.14062-0.14453 0.10156-0.21875 0.23828-0.21875 0.40625 0 0.17578 0.078125 0.30469 0.23438 0.39062 0.15625 0.082031 0.41797 0.16016 0.78125 0.23438 0.35547 0.082031 0.61719 0.19531 0.78125 0.34375 0.15625 0.14453 0.23438 0.33203 0.23438 0.5625 0 0.25781-0.097656 0.47266-0.29688 0.64062-0.20703 0.16406-0.48438 0.25-0.82812 0.25-0.36328 0-0.64844-0.085937-0.85938-0.25-0.21875-0.16797-0.33594-0.40625-0.35938-0.71875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.84375 0h0.4375v0.45312h-0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.9688 3.25 1.2656-3.25h0.42188l1.25 3.25h-0.45312l-0.84375-2.3594c-0.0625-0.15625-0.11328-0.33594-0.15625-0.53125h-0.015625c-0.039062 0.17578-0.097656 0.35156-0.17188 0.53125l-0.85938 2.3594z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.8906 0h0.4375l1.6875 2.5469v-2.5469h0.40625v3.25h-0.4375l-1.6719-2.5469h-0.015625v2.5469h-0.40625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.6875 0h0.39062v2.5312c0.19922-0.1875 0.46484-0.34375 0.79688-0.46875v0.375c-0.45703 0.21875-0.76953 0.49219-0.9375 0.82812h-0.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.2969 0.78125h0.4375v-0.78125h0.39062v0.78125h1.4062v0.35938l-1.4688 2.1094h-0.32812v-2.1094h-0.4375zm0.82812 0.35938v1.4688h0.015625l1-1.4688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.59375 1.6719c-0.17578 0.28906-0.42969 0.4375-0.76562 0.4375-0.26953 0-0.49219-0.10156-0.67188-0.29688-0.1875-0.19922-0.28125-0.44922-0.28125-0.75 0-0.3125 0.09375-0.57812 0.28125-0.79688 0.17969-0.21875 0.41797-0.32812 0.71875-0.32812 0.3125 0 0.57812 0.11328 0.79688 0.34375 0.21875 0.23828 0.32812 0.64844 0.32812 1.2344 0 0.58203-0.097656 1.0195-0.29688 1.3125-0.19531 0.28906-0.48438 0.4375-0.85938 0.4375-0.23828 0-0.44141-0.070313-0.60938-0.20312-0.16406-0.13672-0.26953-0.33984-0.3125-0.60938l0.40625-0.03125c0.074219 0.34375 0.25781 0.51562 0.54688 0.51562 0.19922 0 0.37109-0.10547 0.51562-0.3125 0.14844-0.19922 0.21875-0.51562 0.21875-0.95312zm-0.70312-1.4062c-0.17578 0-0.32031 0.070313-0.4375 0.21875-0.11328 0.15625-0.17188 0.33594-0.17188 0.54688 0 0.20703 0.058594 0.37891 0.17188 0.51562 0.11719 0.13281 0.26562 0.20312 0.45312 0.20312 0.17969 0 0.32812-0.0625 0.45312-0.1875s0.1875-0.29688 0.1875-0.51562c0-0.21094-0.0625-0.39062-0.1875-0.54688s-0.28125-0.23438-0.46875-0.23438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.2969 2.8906c0.3125-0.34375 0.58984-0.77734 0.82812-1.2969 0.23047-0.51172 0.36719-1.043 0.40625-1.5938h0.39062c-0.007813 0.4375-0.11328 0.92188-0.3125 1.4531-0.20703 0.53125-0.47656 0.98438-0.8125 1.3594h1.5781v0.39062h-2.0781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.7031 1.75c-0.19531-0.03125-0.34766-0.125-0.45312-0.28125-0.10156-0.15625-0.15625-0.32812-0.15625-0.51562 0-0.29297 0.10938-0.53906 0.32812-0.73438 0.21094-0.1875 0.46484-0.28125 0.76562-0.28125 0.28125 0 0.51562 0.082031 0.70312 0.25 0.17969 0.16406 0.28125 0.39062 0.3125 0.67188l-0.39062 0.046875c-0.039062-0.21094-0.11328-0.37109-0.21875-0.48438-0.10156-0.10547-0.23828-0.15625-0.40625-0.15625-0.1875 0-0.34375 0.0625-0.46875 0.1875-0.13281 0.13281-0.20312 0.30078-0.20312 0.5 0 0.17578 0.0625 0.32031 0.1875 0.4375 0.11719 0.125 0.26562 0.1875 0.45312 0.1875 0.074219 0 0.16797-0.015625 0.28125-0.046875l-0.046875 0.35938c-0.11328 0-0.19531 0.00391-0.25 0.015625-0.0625 0.00781-0.12891 0.03125-0.20312 0.0625-0.082031 0.039062-0.14844 0.097656-0.20312 0.17188-0.050781 0.082031-0.078125 0.17578-0.078125 0.28125 0 0.16406 0.058594 0.28906 0.17188 0.375 0.10547 0.09375 0.22656 0.14062 0.35938 0.14062 0.16797 0 0.30469-0.054688 0.40625-0.15625 0.09375-0.10547 0.15234-0.25 0.17188-0.4375l0.40625 0.078125c-0.050781 0.28125-0.16406 0.48828-0.34375 0.625-0.17578 0.14453-0.38281 0.21875-0.625 0.21875-0.26953 0-0.49219-0.085937-0.67188-0.25-0.17578-0.16797-0.26562-0.36719-0.26562-0.59375 0-0.30469 0.14844-0.52344 0.4375-0.65625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.25 3.2656c-0.69531 0-1.0469-0.55859-1.0469-1.6719 0-0.55469 0.089844-0.96875 0.26562-1.25 0.17969-0.27344 0.4375-0.40625 0.78125-0.40625 0.69922 0 1.0469 0.55078 1.0469 1.6562 0 0.5625-0.085937 0.97656-0.26562 1.25-0.1875 0.28125-0.44531 0.42188-0.78125 0.42188zm0-3c-0.20703 0-0.36328 0.10156-0.46875 0.3125-0.11328 0.20703-0.17188 0.54688-0.17188 1.0156 0 0.33203 0.027344 0.59375 0.078125 0.78125 0.042969 0.1875 0.10938 0.32812 0.20312 0.42188s0.21484 0.14062 0.35938 0.14062c0.21875 0 0.38281-0.10938 0.48438-0.32812 0.10547-0.21094 0.15625-0.54688 0.15625-1.0156 0-0.32422-0.019531-0.57812-0.0625-0.76562-0.050781-0.1875-0.125-0.32812-0.21875-0.42188s-0.21094-0.14062-0.35938-0.14062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.3594 0h2.0156v3.25h-0.42188v-2.8594h-1.5938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.8906 1.375c0-0.16797 0.011719-0.32422 0.03125-0.46875 0.023437-0.14844 0.074219-0.29297 0.15625-0.4375 0.074219-0.14844 0.19922-0.27344 0.375-0.375 0.17969-0.10156 0.41406-0.15625 0.70312-0.15625 0.28125 0 0.51172 0.042969 0.6875 0.125 0.17969 0.09375 0.30859 0.20703 0.39062 0.34375 0.085937 0.14453 0.13672 0.29688 0.15625 0.45312 0.023437 0.15625 0.03125 0.32812 0.03125 0.51562v1.875h-0.42188v-1.875c0-0.19922-0.007812-0.37109-0.03125-0.51562-0.03125-0.13672-0.10156-0.26172-0.21875-0.375-0.125-0.10547-0.3125-0.15625-0.5625-0.15625s-0.4375 0.039063-0.5625 0.125c-0.125 0.09375-0.20703 0.21094-0.25 0.35938-0.039062 0.14453-0.0625 0.33203-0.0625 0.5625v1.875h-0.42188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.8906 1.0312c0-0.39844 0.085937-0.67969 0.25-0.84375 0.15625-0.16797 0.375-0.25 0.65625-0.25 0.29297 0 0.51172 0.082031 0.65625 0.25 0.13672 0.16406 0.20312 0.41016 0.20312 0.73438l-0.375 0.0625c0-0.21875-0.039062-0.38672-0.125-0.5-0.082031-0.10547-0.20312-0.15625-0.35938-0.15625-0.14453 0-0.25391 0.035156-0.32812 0.10938-0.070312 0.070312-0.11328 0.14844-0.125 0.23438-0.019531 0.09375-0.03125 0.20703-0.03125 0.34375v2.2344h-0.42188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.2656 0h2.125c0 0.1875-0.0625 0.375-0.1875 0.5625s-0.36328 0.42188-0.71875 0.70312c-0.20703 0.16406-0.39453 0.34375-0.5625 0.53125-0.16406 0.1875-0.25 0.375-0.25 0.5625 0 0.16406 0.058594 0.30078 0.17188 0.40625 0.11719 0.11328 0.26172 0.17188 0.4375 0.17188 0.17969 0 0.32812-0.058594 0.45312-0.17188 0.11719-0.10547 0.17188-0.26562 0.17188-0.48438l0.40625 0.046875c-0.019531 0.30078-0.125 0.53125-0.3125 0.6875-0.19531 0.16406-0.44141 0.25-0.73438 0.25-0.3125 0-0.55469-0.089844-0.73438-0.26562-0.17578-0.17969-0.26562-0.39062-0.26562-0.64062 0-0.21094 0.078125-0.42188 0.23438-0.64062 0.14844-0.21094 0.4375-0.49219 0.875-0.84375 0.24219-0.1875 0.39844-0.35156 0.46875-0.48438h-1.5781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.5312 2.8594h1.75v-1h-1.5156v-0.39062h1.5156v-1.4688h0.42188v3.25h-2.1719z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.85938 1.8906h0.45312v0.45312h-0.45312zm0-1.8906h0.45312v0.45312h-0.45312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.9062 1.5312c0.074219-0.125 0.17969-0.23047 0.3125-0.3125 0.13672-0.074219 0.28906-0.10938 0.45312-0.10938 0.26172 0 0.48438 0.09375 0.67188 0.28125 0.1875 0.19531 0.28125 0.45312 0.28125 0.76562 0 0.32031-0.09375 0.58594-0.28125 0.79688-0.19531 0.20703-0.44141 0.3125-0.73438 0.3125-0.30078 0-0.5625-0.12109-0.78125-0.35938-0.21875-0.23047-0.32812-0.63672-0.32812-1.2188 0-0.58594 0.10156-1.0234 0.29688-1.3125 0.19922-0.29297 0.48438-0.4375 0.85938-0.4375 0.24219 0 0.44531 0.066406 0.60938 0.20312 0.15625 0.13281 0.25781 0.33594 0.29688 0.60938l-0.375 0.03125c-0.0625-0.34375-0.24219-0.51562-0.54688-0.51562-0.23828 0-0.42188 0.10938-0.54688 0.32812-0.13281 0.22656-0.20312 0.53906-0.20312 0.9375zm0.67188-0.078125c-0.19531 0-0.35156 0.066406-0.46875 0.20312-0.11328 0.13281-0.17188 0.30469-0.17188 0.51562 0 0.21875 0.0625 0.39844 0.1875 0.54688 0.11719 0.14453 0.26172 0.21875 0.4375 0.21875 0.1875 0 0.34375-0.078125 0.46875-0.23438s0.1875-0.34375 0.1875-0.5625c0-0.19922-0.0625-0.36719-0.1875-0.5-0.125-0.125-0.27344-0.1875-0.45312-0.1875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.71875 1.9531c-0.1875 0.13281-0.39062 0.20312-0.60938 0.20312-0.25781 0-0.48828-0.10156-0.6875-0.29688-0.20703-0.1875-0.3125-0.4375-0.3125-0.75 0-0.32422 0.10547-0.60156 0.3125-0.82812 0.19922-0.23047 0.46484-0.34375 0.79688-0.34375 0.26172 0 0.49219 0.078125 0.6875 0.23438 0.19922 0.15625 0.3125 0.38281 0.34375 0.6875l-0.42188 0.015625c-0.03125-0.19922-0.097656-0.35156-0.20312-0.45312-0.11328-0.10547-0.25-0.15625-0.40625-0.15625-0.20703 0-0.375 0.078125-0.5 0.23438s-0.1875 0.34375-0.1875 0.5625c0 0.22656 0.070312 0.40625 0.20312 0.53125 0.125 0.13281 0.28906 0.20312 0.48438 0.20312 0.26172 0 0.46094-0.10547 0.59375-0.3125l0.375 0.046875-0.32812 1.6719h-1.5938v-0.39062h1.2812z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m139.4 127.1v-0.14063h-147.26v-254.83h147.12v254.97h0.14063v-0.14063 0.14063h0.14453v-255.26h-147.69v255.4h147.69v-0.14453",
    fill: "#ed1c24"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-248.14 -308)",
    fill: "#171817"
  }, /*#__PURE__*/React.createElement("use", {
    x: 378.918,
    y: 368.492,
    xlinkHref: "#glyph-3-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 376.10434,
    y: 368.492,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.03281,
    y: 368.492,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 369.70801,
    y: 368.492,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 366.63647,
    y: 368.492,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 364.95041,
    y: 368.492,
    xlinkHref: "#glyph-3-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 361.62561,
    y: 368.492,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 358.04291,
    y: 368.492,
    xlinkHref: "#glyph-3-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 354.20694,
    y: 368.492,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 351.13541,
    y: 368.492,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 349.45001,
    y: 368.492,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 346.37848,
    y: 368.492,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 343.30695,
    y: 368.492,
    xlinkHref: "#glyph-3-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 340.23541,
    y: 368.492,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 337.16388,
    y: 368.492,
    xlinkHref: "#glyph-3-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 333.83908,
    y: 368.492,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 330.76755,
    y: 368.492,
    xlinkHref: "#glyph-3-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 329.48734,
    y: 368.492,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 327.80197,
    y: 368.492,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 324.73044,
    y: 368.492,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 323.45026,
    y: 368.492,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 320.37872,
    y: 368.492,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 319.09854,
    y: 368.492,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 317.41296,
    y: 368.492,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 314.3414,
    y: 368.492,
    xlinkHref: "#glyph-3-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 311.26987,
    y: 368.492,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 309.98969,
    y: 368.492,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 308.30438,
    y: 368.492,
    xlinkHref: "#glyph-3-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 304.97955,
    y: 368.492,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 303.69937,
    y: 368.492,
    xlinkHref: "#glyph-3-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 300.62784,
    y: 368.492,
    xlinkHref: "#glyph-3-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 297.30304,
    y: 368.492,
    xlinkHref: "#glyph-3-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 294.48938,
    y: 368.492,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 291.41785,
    y: 368.492,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288.09302,
    y: 368.492,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 286.81284,
    y: 368.492,
    xlinkHref: "#glyph-3-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 283.23013,
    y: 368.492,
    xlinkHref: "#glyph-3-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 279.90533,
    y: 368.492,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 278.62515,
    y: 368.492,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 276.93954,
    y: 368.492,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 273.86801,
    y: 368.492,
    xlinkHref: "#glyph-3-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 270.54318,
    y: 368.492,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 269.263,
    y: 368.492,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 267.57745,
    y: 368.492,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 266.29724,
    y: 368.492,
    xlinkHref: "#glyph-3-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 262.97244,
    y: 368.492,
    xlinkHref: "#glyph-3-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 259.64764,
    y: 368.492,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 258.36743,
    y: 368.492,
    xlinkHref: "#glyph-3-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 255.55379,
    y: 368.492,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 252.48225,
    y: 368.492,
    xlinkHref: "#glyph-3-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 249.41072,
    y: 368.492,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 248.13052,
    y: 368.492,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.918,
    y: 363.8916,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 375.84647,
    y: 363.8916,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 372.52167,
    y: 363.8916,
    xlinkHref: "#glyph-3-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 369.70801,
    y: 363.8916,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 366.63647,
    y: 363.8916,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 365.35626,
    y: 363.8916,
    xlinkHref: "#glyph-3-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 362.28473,
    y: 363.8916,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 358.70206,
    y: 363.8916,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 357.42188,
    y: 363.8916,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 351.53363,
    y: 363.8916,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 348.4621,
    y: 363.8916,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 342.57385,
    y: 363.8916,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 339.24905,
    y: 363.8916,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 335.66635,
    y: 363.8916,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 332.34155,
    y: 363.8916,
    xlinkHref: "#glyph-3-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 329.01675,
    y: 363.8916,
    xlinkHref: "#glyph-3-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 325.69193,
    y: 363.8916,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 322.62039,
    y: 363.8916,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 316.73209,
    y: 363.8916,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 313.40726,
    y: 363.8916,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 312.12708,
    y: 363.8916,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 310.84689,
    y: 363.8916,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 309.56671,
    y: 363.8916,
    xlinkHref: "#glyph-3-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 306.75305,
    y: 363.8916,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 305.47287,
    y: 363.8916,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 299.58408,
    y: 363.8916,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 296.51254,
    y: 363.8916,
    xlinkHref: "#glyph-3-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 294.97906,
    y: 363.8916,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 292.4187,
    y: 363.8916,
    xlinkHref: "#glyph-3-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 289.85831,
    y: 363.8916,
    xlinkHref: "#glyph-3-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 287.29794,
    y: 363.8916,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 284.73755,
    y: 363.8916,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 282.17719,
    y: 363.8916,
    xlinkHref: "#glyph-3-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 279.61679,
    y: 363.8916,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 277.05643,
    y: 363.8916,
    xlinkHref: "#glyph-3-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 274.49603,
    y: 363.8916,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 268.60712,
    y: 363.8916,
    xlinkHref: "#glyph-3-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 265.79346,
    y: 363.8916,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 262.72192,
    y: 363.8916,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 259.65039,
    y: 363.8916,
    xlinkHref: "#glyph-3-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 256.32559,
    y: 363.8916,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 255.04539,
    y: 363.8916,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 251.46269,
    y: 363.8916,
    xlinkHref: "#glyph-3-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 248.13789,
    y: 363.8916,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.918,
    y: 359.29123,
    xlinkHref: "#glyph-3-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 376.3576,
    y: 359.29123,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 372.77493,
    y: 359.29123,
    xlinkHref: "#glyph-3-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 369.19223,
    y: 359.29123,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 367.91205,
    y: 359.29123,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 364.84052,
    y: 359.29123,
    xlinkHref: "#glyph-3-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 362.02686,
    y: 359.29123,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360.74667,
    y: 359.29123,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 357.42188,
    y: 359.29123,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 354.35031,
    y: 359.29123,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 350.09457,
    y: 359.29123,
    xlinkHref: "#glyph-3-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 347.53418,
    y: 359.29123,
    xlinkHref: "#glyph-3-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 344.97382,
    y: 359.29123,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 341.64902,
    y: 359.29123,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 337.39301,
    y: 359.29123,
    xlinkHref: "#glyph-3-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 334.57935,
    y: 359.29123,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 331.50781,
    y: 359.29123,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 328.18301,
    y: 359.29123,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 325.11148,
    y: 359.29123,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 320.85471,
    y: 359.29123,
    xlinkHref: "#glyph-3-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 317.52991,
    y: 359.29123,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 313.94724,
    y: 359.29123,
    xlinkHref: "#glyph-3-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 310.11127,
    y: 359.29123,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 307.03973,
    y: 359.29123,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 302.78284,
    y: 359.29123,
    xlinkHref: "#glyph-3-32"
  }), /*#__PURE__*/React.createElement("use", {
    x: 299.7113,
    y: 359.29123,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 296.38651,
    y: 359.29123,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 293.31497,
    y: 359.29123,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 290.24344,
    y: 359.29123,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288.96323,
    y: 359.29123,
    xlinkHref: "#glyph-3-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 286.40286,
    y: 359.29123,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 282.14731,
    y: 359.29123,
    xlinkHref: "#glyph-3-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 279.07578,
    y: 359.29123,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 277.79559,
    y: 359.29123,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 273.53873,
    y: 359.29123,
    xlinkHref: "#glyph-3-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 270.97836,
    y: 359.29123,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 269.69815,
    y: 359.29123,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 265.4415,
    y: 359.29123,
    xlinkHref: "#glyph-3-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 262.8811,
    y: 359.29123,
    xlinkHref: "#glyph-3-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 260.06744,
    y: 359.29123,
    xlinkHref: "#glyph-3-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 256.74265,
    y: 359.29123,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 253.6711,
    y: 359.29123,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 249.41414,
    y: 359.29123,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 248.13394,
    y: 359.29123,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.918,
    y: 354.69083,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 375.5932,
    y: 354.69083,
    xlinkHref: "#glyph-3-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 372.26837,
    y: 354.69083,
    xlinkHref: "#glyph-3-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 369.19684,
    y: 354.69083,
    xlinkHref: "#glyph-3-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 366.89435,
    y: 354.69083,
    xlinkHref: "#glyph-3-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 365.61417,
    y: 354.69083,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 363.05377,
    y: 354.69083,
    xlinkHref: "#glyph-3-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360.49341,
    y: 354.69083,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 359.2132,
    y: 354.69083,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 356.65283,
    y: 354.69083,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 354.09244,
    y: 354.69083,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 351.53207,
    y: 354.69083,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 350.25186,
    y: 354.69083,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 347.6915,
    y: 354.69083,
    xlinkHref: "#glyph-3-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 345.1311,
    y: 354.69083,
    xlinkHref: "#glyph-3-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 342.57074,
    y: 354.69083,
    xlinkHref: "#glyph-3-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 341.29056,
    y: 354.69083,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 338.73016,
    y: 354.69083,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 336.1698,
    y: 354.69083,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 333.60941,
    y: 354.69083,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 331.04901,
    y: 354.69083,
    xlinkHref: "#glyph-3-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 329.51556,
    y: 354.69083,
    xlinkHref: "#glyph-3-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 326.95517,
    y: 354.69083,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 324.39481,
    y: 354.69083,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 317.42188,
    y: 354.69083,
    xlinkHref: "#glyph-3-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 313.58591,
    y: 354.69083,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 310.0032,
    y: 354.69083,
    xlinkHref: "#glyph-3-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 306.67841,
    y: 354.69083,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 303.60687,
    y: 354.69083,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 296.6344,
    y: 354.69083,
    xlinkHref: "#glyph-3-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 293.30957,
    y: 354.69083,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 289.7269,
    y: 354.69083,
    xlinkHref: "#glyph-3-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 285.89093,
    y: 354.69083,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 282.8194,
    y: 354.69083,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 275.8465,
    y: 354.69083,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 272.77496,
    y: 354.69083,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 271.49478,
    y: 354.69083,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 268.42325,
    y: 354.69083,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 267.14304,
    y: 354.69083,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 264.0715,
    y: 354.69083,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 262.79132,
    y: 354.69083,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 255.81839,
    y: 354.69083,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 252.74684,
    y: 354.69083,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 251.46666,
    y: 354.69083,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 248.14185,
    y: 354.69083,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.918,
    y: 350.09045,
    xlinkHref: "#glyph-3-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 376.3576,
    y: 350.09045,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.79724,
    y: 350.09045,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 371.23685,
    y: 350.09045,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 369.95667,
    y: 350.09045,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 367.3963,
    y: 350.09045,
    xlinkHref: "#glyph-3-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 364.83591,
    y: 350.09045,
    xlinkHref: "#glyph-3-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 362.27554,
    y: 350.09045,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360.99533,
    y: 350.09045,
    xlinkHref: "#glyph-3-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 358.43497,
    y: 350.09045,
    xlinkHref: "#glyph-3-39"
  }), /*#__PURE__*/React.createElement("use", {
    x: 355.87457,
    y: 350.09045,
    xlinkHref: "#glyph-3-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 353.31421,
    y: 350.09045,
    xlinkHref: "#glyph-3-40"
  }), /*#__PURE__*/React.createElement("use", {
    x: 348.7092,
    y: 350.09045,
    xlinkHref: "#glyph-3-41"
  }), /*#__PURE__*/React.createElement("use", {
    x: 344.10419,
    y: 350.09045,
    xlinkHref: "#glyph-3-42"
  }), /*#__PURE__*/React.createElement("use", {
    x: 339.49921,
    y: 350.09045,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 338.21902,
    y: 350.09045,
    xlinkHref: "#glyph-3-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 335.40536,
    y: 350.09045,
    xlinkHref: "#glyph-3-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 332.33383,
    y: 350.09045,
    xlinkHref: "#glyph-3-43"
  }), /*#__PURE__*/React.createElement("use", {
    x: 327.72882,
    y: 350.09045,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 323.05865,
    y: 350.09045,
    xlinkHref: "#glyph-3-44"
  }), /*#__PURE__*/React.createElement("use", {
    x: 318.45367,
    y: 350.09045,
    xlinkHref: "#glyph-3-45"
  }), /*#__PURE__*/React.createElement("use", {
    x: 313.84866,
    y: 350.09045,
    xlinkHref: "#glyph-3-46"
  }), /*#__PURE__*/React.createElement("use", {
    x: 309.24368,
    y: 350.09045,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 308.0759,
    y: 350.09045,
    xlinkHref: "#glyph-3-47"
  }), /*#__PURE__*/React.createElement("use", {
    x: 306.54242,
    y: 350.09045,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 303.98203,
    y: 350.09045,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 301.42166,
    y: 350.09045,
    xlinkHref: "#glyph-3-39"
  }), /*#__PURE__*/React.createElement("use", {
    x: 298.86127,
    y: 350.09045,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 296.3009,
    y: 350.09045,
    xlinkHref: "#glyph-3-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 294.76743,
    y: 350.09045,
    xlinkHref: "#glyph-3-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 292.20706,
    y: 350.09045,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 289.64667,
    y: 350.09045,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 287.0863,
    y: 350.09045,
    xlinkHref: "#glyph-3-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 285.55283,
    y: 350.09045,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 282.99246,
    y: 350.09045,
    xlinkHref: "#glyph-3-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 280.43207,
    y: 350.09045,
    xlinkHref: "#glyph-3-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 277.87167,
    y: 350.09045,
    xlinkHref: "#glyph-3-48"
  }), /*#__PURE__*/React.createElement("use", {
    x: 276.33823,
    y: 350.09045,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 275.05804,
    y: 350.09045,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 273.89111,
    y: 350.09045,
    xlinkHref: "#glyph-3-49"
  }), /*#__PURE__*/React.createElement("use", {
    x: 271.33075,
    y: 350.09045,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 268.00592,
    y: 350.09045,
    xlinkHref: "#glyph-3-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 264.68112,
    y: 350.09045,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 263.5134,
    y: 350.09045,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 260.953,
    y: 350.09045,
    xlinkHref: "#glyph-3-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 258.39264,
    y: 350.09045,
    xlinkHref: "#glyph-3-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 255.83224,
    y: 350.09045,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 253.27187,
    y: 350.09045,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 250.71149,
    y: 350.09045,
    xlinkHref: "#glyph-3-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 248.15111,
    y: 350.09045,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.918,
    y: 345.49005,
    xlinkHref: "#glyph-3-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 376.10434,
    y: 345.49005,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.03281,
    y: 345.49005,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 369.70801,
    y: 345.49005,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 366.63647,
    y: 345.49005,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 365.28088,
    y: 345.49005,
    xlinkHref: "#glyph-3-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 361.95609,
    y: 345.49005,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 358.37338,
    y: 345.49005,
    xlinkHref: "#glyph-3-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 354.53741,
    y: 345.49005,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 351.46588,
    y: 345.49005,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 350.11057,
    y: 345.49005,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 346.78577,
    y: 345.49005,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 343.71423,
    y: 345.49005,
    xlinkHref: "#glyph-3-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 340.3894,
    y: 345.49005,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 337.31787,
    y: 345.49005,
    xlinkHref: "#glyph-3-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 333.99307,
    y: 345.49005,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 330.92154,
    y: 345.49005,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 329.56564,
    y: 345.49005,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 328.28546,
    y: 345.49005,
    xlinkHref: "#glyph-3-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 324.96063,
    y: 345.49005,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 321.63583,
    y: 345.49005,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 320.35565,
    y: 345.49005,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 319.00043,
    y: 345.49005,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 315.67563,
    y: 345.49005,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 312.60406,
    y: 345.49005,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 311.24887,
    y: 345.49005,
    xlinkHref: "#glyph-3-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 308.68848,
    y: 345.49005,
    xlinkHref: "#glyph-3-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 306.12811,
    y: 345.49005,
    xlinkHref: "#glyph-3-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 303.56772,
    y: 345.49005,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 301.00735,
    y: 345.49005,
    xlinkHref: "#glyph-3-39"
  }), /*#__PURE__*/React.createElement("use", {
    x: 298.44696,
    y: 345.49005,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 297.09143,
    y: 345.49005,
    xlinkHref: "#glyph-3-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 293.25546,
    y: 345.49005,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 289.67279,
    y: 345.49005,
    xlinkHref: "#glyph-3-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 286.34796,
    y: 345.49005,
    xlinkHref: "#glyph-3-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 283.5343,
    y: 345.49005,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 280.2095,
    y: 345.49005,
    xlinkHref: "#glyph-3-50"
  }), /*#__PURE__*/React.createElement("use", {
    x: 277.13797,
    y: 345.49005,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 274.06644,
    y: 345.49005,
    xlinkHref: "#glyph-3-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 271.50604,
    y: 345.49005,
    xlinkHref: "#glyph-3-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 270.22586,
    y: 345.49005,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 268.86917,
    y: 345.49005,
    xlinkHref: "#glyph-3-51"
  }), /*#__PURE__*/React.createElement("use", {
    x: 265.28647,
    y: 345.49005,
    xlinkHref: "#glyph-3-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 261.96167,
    y: 345.49005,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 258.89014,
    y: 345.49005,
    xlinkHref: "#glyph-3-32"
  }), /*#__PURE__*/React.createElement("use", {
    x: 255.81859,
    y: 345.49005,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 252.74706,
    y: 345.49005,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 249.42224,
    y: 345.49005,
    xlinkHref: "#glyph-3-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 248.14206,
    y: 345.49005,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.918,
    y: 340.88965,
    xlinkHref: "#glyph-3-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 375.5932,
    y: 340.88965,
    xlinkHref: "#glyph-3-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.03281,
    y: 340.88965,
    xlinkHref: "#glyph-3-32"
  }), /*#__PURE__*/React.createElement("use", {
    x: 369.96127,
    y: 340.88965,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 366.41644,
    y: 340.88965,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 363.85605,
    y: 340.88965,
    xlinkHref: "#glyph-3-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360.27338,
    y: 340.88965,
    xlinkHref: "#glyph-3-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 357.71298,
    y: 340.88965,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 356.4328,
    y: 340.88965,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 352.88794,
    y: 340.88965,
    xlinkHref: "#glyph-3-52"
  }), /*#__PURE__*/React.createElement("use", {
    x: 348.28293,
    y: 340.88965,
    xlinkHref: "#glyph-3-53"
  }), /*#__PURE__*/React.createElement("use", {
    x: 343.67795,
    y: 340.88965,
    xlinkHref: "#glyph-3-54"
  }), /*#__PURE__*/React.createElement("use", {
    x: 339.07294,
    y: 340.88965,
    xlinkHref: "#glyph-3-55"
  }), /*#__PURE__*/React.createElement("use", {
    x: 334.46793,
    y: 340.88965,
    xlinkHref: "#glyph-3-56"
  }), /*#__PURE__*/React.createElement("use", {
    x: 329.86295,
    y: 340.88965,
    xlinkHref: "#glyph-3-57"
  }), /*#__PURE__*/React.createElement("use", {
    x: 325.25793,
    y: 340.88965,
    xlinkHref: "#glyph-3-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 320.65292,
    y: 340.88965,
    xlinkHref: "#glyph-3-52"
  }), /*#__PURE__*/React.createElement("use", {
    x: 316.04794,
    y: 340.88965,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 312.504,
    y: 340.88965,
    xlinkHref: "#glyph-3-59"
  }), /*#__PURE__*/React.createElement("use", {
    x: 307.89899,
    y: 340.88965,
    xlinkHref: "#glyph-3-60"
  }), /*#__PURE__*/React.createElement("use", {
    x: 303.29401,
    y: 340.88965,
    xlinkHref: "#glyph-3-61"
  }), /*#__PURE__*/React.createElement("use", {
    x: 298.689,
    y: 340.88965,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 295.14505,
    y: 340.88965,
    xlinkHref: "#glyph-3-62"
  }), /*#__PURE__*/React.createElement("use", {
    x: 290.54004,
    y: 340.88965,
    xlinkHref: "#glyph-3-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 285.93503,
    y: 340.88965,
    xlinkHref: "#glyph-3-64"
  }), /*#__PURE__*/React.createElement("use", {
    x: 281.33005,
    y: 340.88965,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 277.78531,
    y: 340.88965,
    xlinkHref: "#glyph-3-65"
  }), /*#__PURE__*/React.createElement("use", {
    x: 273.1803,
    y: 340.88965,
    xlinkHref: "#glyph-3-66"
  }), /*#__PURE__*/React.createElement("use", {
    x: 268.57529,
    y: 340.88965,
    xlinkHref: "#glyph-3-67"
  }), /*#__PURE__*/React.createElement("use", {
    x: 263.97031,
    y: 340.88965,
    xlinkHref: "#glyph-3-68"
  }), /*#__PURE__*/React.createElement("use", {
    x: 259.3653,
    y: 340.88965,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 255.82127,
    y: 340.88965,
    xlinkHref: "#glyph-3-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 253.26089,
    y: 340.88965,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 250.70052,
    y: 340.88965,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 248.14014,
    y: 340.88965,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.918,
    y: 336.28928,
    xlinkHref: "#glyph-3-69"
  }), /*#__PURE__*/React.createElement("use", {
    x: 374.31299,
    y: 336.28928,
    xlinkHref: "#glyph-3-70"
  }), /*#__PURE__*/React.createElement("use", {
    x: 369.70801,
    y: 336.28928,
    xlinkHref: "#glyph-3-53"
  }), /*#__PURE__*/React.createElement("use", {
    x: 365.103,
    y: 336.28928,
    xlinkHref: "#glyph-3-71"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360.49799,
    y: 336.28928,
    xlinkHref: "#glyph-3-72"
  }), /*#__PURE__*/React.createElement("use", {
    x: 355.89301,
    y: 336.28928,
    xlinkHref: "#glyph-3-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 351.28799,
    y: 336.28928,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 344.38092,
    y: 336.28928,
    xlinkHref: "#glyph-3-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 341.82053,
    y: 336.28928,
    xlinkHref: "#glyph-3-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 339.26016,
    y: 336.28928,
    xlinkHref: "#glyph-3-74"
  }), /*#__PURE__*/React.createElement("use", {
    x: 334.65515,
    y: 336.28928,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 327.7489,
    y: 336.28928,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 325.18851,
    y: 336.28928,
    xlinkHref: "#glyph-3-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 322.62814,
    y: 336.28928,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 320.06775,
    y: 336.28928,
    xlinkHref: "#glyph-3-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 318.5343,
    y: 336.28928,
    xlinkHref: "#glyph-3-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 315.97391,
    y: 336.28928,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 313.41354,
    y: 336.28928,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 310.85315,
    y: 336.28928,
    xlinkHref: "#glyph-3-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 309.3197,
    y: 336.28928,
    xlinkHref: "#glyph-3-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 306.75931,
    y: 336.28928,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 304.19891,
    y: 336.28928,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 301.63855,
    y: 336.28928,
    xlinkHref: "#glyph-3-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 299.07816,
    y: 336.28928,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 297.79797,
    y: 336.28928,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 290.89108,
    y: 336.28928,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 287.56625,
    y: 336.28928,
    xlinkHref: "#glyph-3-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 284.24146,
    y: 336.28928,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 280.91666,
    y: 336.28928,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 274.00943,
    y: 336.28928,
    xlinkHref: "#glyph-3-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 271.44904,
    y: 336.28928,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 268.88867,
    y: 336.28928,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 266.32828,
    y: 336.28928,
    xlinkHref: "#glyph-3-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 263.76791,
    y: 336.28928,
    xlinkHref: "#glyph-3-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 261.20752,
    y: 336.28928,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 258.64716,
    y: 336.28928,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 256.08676,
    y: 336.28928,
    xlinkHref: "#glyph-3-39"
  }), /*#__PURE__*/React.createElement("use", {
    x: 253.52638,
    y: 336.28928,
    xlinkHref: "#glyph-3-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 251.99292,
    y: 336.28928,
    xlinkHref: "#glyph-3-39"
  }), /*#__PURE__*/React.createElement("use", {
    x: 249.43254,
    y: 336.28928,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 248.15234,
    y: 336.28928,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.918,
    y: 330.64359,
    xlinkHref: "#glyph-3-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 375.08203,
    y: 330.64359,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 372.0105,
    y: 330.64359,
    xlinkHref: "#glyph-3-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 370.47702,
    y: 330.64359,
    xlinkHref: "#glyph-3-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 366.64108,
    y: 330.64359,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 363.56955,
    y: 330.64359,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360.24472,
    y: 330.64359,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 356.66205,
    y: 330.64359,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 353.33722,
    y: 330.64359,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 351.38245,
    y: 330.64359,
    xlinkHref: "#glyph-3-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 350.10226,
    y: 330.64359,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 348.14615,
    y: 330.64359,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 345.07462,
    y: 330.64359,
    xlinkHref: "#glyph-3-75"
  }), /*#__PURE__*/React.createElement("use", {
    x: 343.7944,
    y: 330.64359,
    xlinkHref: "#glyph-3-76"
  }), /*#__PURE__*/React.createElement("use", {
    x: 341.23404,
    y: 330.64359,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 339.2778,
    y: 330.64359,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 335.95297,
    y: 330.64359,
    xlinkHref: "#glyph-3-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 333.13934,
    y: 330.64359,
    xlinkHref: "#glyph-3-77"
  }), /*#__PURE__*/React.createElement("use", {
    x: 328.79221,
    y: 330.64359,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 326.836,
    y: 330.64359,
    xlinkHref: "#glyph-3-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 323.00003,
    y: 330.64359,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 319.9285,
    y: 330.64359,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 316.6037,
    y: 330.64359,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 313.021,
    y: 330.64359,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 309.6962,
    y: 330.64359,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 307.7399,
    y: 330.64359,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 306.45972,
    y: 330.64359,
    xlinkHref: "#glyph-3-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 303.64606,
    y: 330.64359,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 301.69031,
    y: 330.64359,
    xlinkHref: "#glyph-3-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 300.41013,
    y: 330.64359,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 298.45438,
    y: 330.64359,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 295.89401,
    y: 330.64359,
    xlinkHref: "#glyph-3-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 293.33362,
    y: 330.64359,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 290.77325,
    y: 330.64359,
    xlinkHref: "#glyph-3-39"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288.21286,
    y: 330.64359,
    xlinkHref: "#glyph-3-39"
  }), /*#__PURE__*/React.createElement("use", {
    x: 285.6525,
    y: 330.64359,
    xlinkHref: "#glyph-3-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 283.0921,
    y: 330.64359,
    xlinkHref: "#glyph-3-39"
  }), /*#__PURE__*/React.createElement("use", {
    x: 280.53174,
    y: 330.64359,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 279.25153,
    y: 330.64359,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 275.38266,
    y: 330.647,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 274.13181,
    y: 330.647,
    xlinkHref: "#glyph-4-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 270.38373,
    y: 330.647,
    xlinkHref: "#glyph-4-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 267.38254,
    y: 330.647,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 263.88193,
    y: 330.647,
    xlinkHref: "#glyph-4-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 260.6333,
    y: 330.647,
    xlinkHref: "#glyph-4-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 257.88409,
    y: 330.647,
    xlinkHref: "#glyph-4-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 254.88293,
    y: 330.647,
    xlinkHref: "#glyph-4-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 251.63429,
    y: 330.647,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 248.13368,
    y: 330.647,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.91974,
    y: 325.00131,
    xlinkHref: "#glyph-4-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 375.91858,
    y: 325.00131,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 372.41797,
    y: 325.00131,
    xlinkHref: "#glyph-4-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 369.16931,
    y: 325.00131,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 367.3537,
    y: 325.00131,
    xlinkHref: "#glyph-4-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 364.60452,
    y: 325.00131,
    xlinkHref: "#glyph-4-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 361.60336,
    y: 325.00131,
    xlinkHref: "#glyph-4-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 358.35471,
    y: 325.00131,
    xlinkHref: "#glyph-4-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 355.35355,
    y: 325.00131,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 353.53809,
    y: 325.00131,
    xlinkHref: "#glyph-4-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 350.28943,
    y: 325.00131,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 346.78882,
    y: 325.00131,
    xlinkHref: "#glyph-4-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 343.04074,
    y: 325.00131,
    xlinkHref: "#glyph-4-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 340.03958,
    y: 325.00131,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 338.224,
    y: 325.00131,
    xlinkHref: "#glyph-4-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 334.47592,
    y: 325.00131,
    xlinkHref: "#glyph-4-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 331.47473,
    y: 325.00131,
    xlinkHref: "#glyph-4-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 328.47357,
    y: 325.00131,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 327.22272,
    y: 325.00131,
    xlinkHref: "#glyph-4-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 323.97406,
    y: 325.00131,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 320.47345,
    y: 325.00131,
    xlinkHref: "#glyph-4-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 319.2226,
    y: 325.00131,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 317.40717,
    y: 325.00131,
    xlinkHref: "#glyph-4-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 314.40601,
    y: 325.00131,
    xlinkHref: "#glyph-4-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 313.15512,
    y: 325.00131,
    xlinkHref: "#glyph-4-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 310.15396,
    y: 325.00131,
    xlinkHref: "#glyph-4-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 308.90311,
    y: 325.00131,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 307.08762,
    y: 325.00131,
    xlinkHref: "#glyph-4-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 303.83899,
    y: 325.00131,
    xlinkHref: "#glyph-4-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 300.8378,
    y: 325.00131,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 299.02237,
    y: 325.00131,
    xlinkHref: "#glyph-4-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 295.77374,
    y: 325.00131,
    xlinkHref: "#glyph-4-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 294.52289,
    y: 325.00131,
    xlinkHref: "#glyph-4-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 291.5217,
    y: 325.00131,
    xlinkHref: "#glyph-4-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 290.27084,
    y: 325.00131,
    xlinkHref: "#glyph-4-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 287.26968,
    y: 325.00131,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 283.76907,
    y: 325.00131,
    xlinkHref: "#glyph-4-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 280.52042,
    y: 325.00131,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 279.26956,
    y: 325.00131,
    xlinkHref: "#glyph-4-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 276.2684,
    y: 325.00131,
    xlinkHref: "#glyph-4-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 273.01974,
    y: 325.00131,
    xlinkHref: "#glyph-4-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 270.27057,
    y: 325.00131,
    xlinkHref: "#glyph-4-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 267.26941,
    y: 325.00131,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 265.45398,
    y: 325.00131,
    xlinkHref: "#glyph-4-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 262.95227,
    y: 325.00131,
    xlinkHref: "#glyph-4-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 260.45053,
    y: 325.00131,
    xlinkHref: "#glyph-4-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 257.94882,
    y: 325.00131,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 256.1333,
    y: 325.00131,
    xlinkHref: "#glyph-4-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 252.88467,
    y: 325.00131,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 249.38405,
    y: 325.00131,
    xlinkHref: "#glyph-4-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 248.13319,
    y: 325.00131,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.91974,
    y: 319.35559,
    xlinkHref: "#glyph-4-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 376.41803,
    y: 319.35559,
    xlinkHref: "#glyph-4-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.91629,
    y: 319.35559,
    xlinkHref: "#glyph-4-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 371.41458,
    y: 319.35559,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 362.72522,
    y: 319.35559,
    xlinkHref: "#glyph-4-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 359.47659,
    y: 319.35559,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 355.97598,
    y: 319.35559,
    xlinkHref: "#glyph-4-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 353.47424,
    y: 319.35559,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 349.97363,
    y: 319.35559,
    xlinkHref: "#glyph-4-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 346.72501,
    y: 319.35559,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 345.47415,
    y: 319.35559,
    xlinkHref: "#glyph-4-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 342.47296,
    y: 319.35559,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 333.78339,
    y: 319.35559,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 332.53253,
    y: 319.35559,
    xlinkHref: "#glyph-4-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 329.28391,
    y: 319.35559,
    xlinkHref: "#glyph-4-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 326.03525,
    y: 319.35559,
    xlinkHref: "#glyph-4-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 322.78662,
    y: 319.35559,
    xlinkHref: "#glyph-4-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 319.78546,
    y: 319.35559,
    xlinkHref: "#glyph-4-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 317.03625,
    y: 319.35559,
    xlinkHref: "#glyph-4-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 313.78763,
    y: 319.35559,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 312.53674,
    y: 319.35559,
    xlinkHref: "#glyph-4-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 309.53558,
    y: 319.35559,
    xlinkHref: "#glyph-4-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 307.03387,
    y: 319.35559,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 298.34393,
    y: 319.35559,
    xlinkHref: "#glyph-4-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 295.34277,
    y: 319.35559,
    xlinkHref: "#glyph-4-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 292.34161,
    y: 319.35559,
    xlinkHref: "#glyph-4-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 289.83987,
    y: 319.35559,
    xlinkHref: "#glyph-4-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 287.33817,
    y: 319.35559,
    xlinkHref: "#glyph-4-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 284.33698,
    y: 319.35559,
    xlinkHref: "#glyph-4-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 282.08725,
    y: 319.35559,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 278.58661,
    y: 319.35559,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 269.89709,
    y: 319.35559,
    xlinkHref: "#glyph-4-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 266.89594,
    y: 319.35559,
    xlinkHref: "#glyph-4-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 264.3942,
    y: 319.35559,
    xlinkHref: "#glyph-4-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 261.14557,
    y: 319.35559,
    xlinkHref: "#glyph-4-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 258.14441,
    y: 319.35559,
    xlinkHref: "#glyph-4-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 255.64268,
    y: 319.35559,
    xlinkHref: "#glyph-4-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 252.39404,
    y: 319.35559,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 251.14317,
    y: 319.35559,
    xlinkHref: "#glyph-4-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 248.14201,
    y: 319.35559,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.91974,
    y: 313.7099,
    xlinkHref: "#glyph-4-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 375.91858,
    y: 313.7099,
    xlinkHref: "#glyph-4-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.16937,
    y: 313.7099,
    xlinkHref: "#glyph-4-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 369.92075,
    y: 313.7099,
    xlinkHref: "#glyph-4-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 366.91956,
    y: 313.7099,
    xlinkHref: "#glyph-4-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 363.9184,
    y: 313.7099,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360.41779,
    y: 313.7099,
    xlinkHref: "#glyph-4-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 357.66861,
    y: 313.7099,
    xlinkHref: "#glyph-4-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 354.9194,
    y: 313.7099,
    xlinkHref: "#glyph-4-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 351.91824,
    y: 313.7099,
    xlinkHref: "#glyph-4-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 349.4165,
    y: 313.7099,
    xlinkHref: "#glyph-4-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 346.16788,
    y: 313.7099,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 342.66727,
    y: 313.7099,
    xlinkHref: "#glyph-4-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 341.41641,
    y: 313.7099,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 335.7627,
    y: 313.7099,
    xlinkHref: "#glyph-4-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 332.51407,
    y: 313.7099,
    xlinkHref: "#glyph-4-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 331.26321,
    y: 313.7099,
    xlinkHref: "#glyph-4-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 328.26202,
    y: 313.7099,
    xlinkHref: "#glyph-4-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 327.01117,
    y: 313.7099,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 321.35721,
    y: 313.7099,
    xlinkHref: "#glyph-4-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 318.8555,
    y: 313.7099,
    xlinkHref: "#glyph-4-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 316.35376,
    y: 313.7099,
    xlinkHref: "#glyph-4-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 313.85205,
    y: 313.7099,
    xlinkHref: "#glyph-4-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 311.35031,
    y: 313.7099,
    xlinkHref: "#glyph-4-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 308.8486,
    y: 313.7099,
    xlinkHref: "#glyph-4-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 307.59775,
    y: 313.7099,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 301.94318,
    y: 313.7099,
    xlinkHref: "#glyph-4-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 298.69455,
    y: 313.7099,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 297.4437,
    y: 313.7099,
    xlinkHref: "#glyph-4-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 294.19504,
    y: 313.7099,
    xlinkHref: "#glyph-4-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 290.94641,
    y: 313.7099,
    xlinkHref: "#glyph-4-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 287.94522,
    y: 313.7099,
    xlinkHref: "#glyph-4-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 284.69659,
    y: 313.7099,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 279.04236,
    y: 313.7099,
    xlinkHref: "#glyph-4-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 275.79373,
    y: 313.7099,
    xlinkHref: "#glyph-4-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 272.79257,
    y: 313.7099,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 267.13922,
    y: 313.7099,
    xlinkHref: "#glyph-4-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 263.39114,
    y: 313.7099,
    xlinkHref: "#glyph-4-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 260.38998,
    y: 313.7099,
    xlinkHref: "#glyph-4-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 257.38882,
    y: 313.7099,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 256.13794,
    y: 313.7099,
    xlinkHref: "#glyph-4-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 252.88931,
    y: 313.7099,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 249.3887,
    y: 313.7099,
    xlinkHref: "#glyph-4-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 248.13783,
    y: 313.7099,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.91974,
    y: 308.06421,
    xlinkHref: "#glyph-4-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 375.67111,
    y: 308.06421,
    xlinkHref: "#glyph-4-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 372.92191,
    y: 308.06421,
    xlinkHref: "#glyph-4-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 369.67328,
    y: 308.06421,
    xlinkHref: "#glyph-4-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 368.42239,
    y: 308.06421,
    xlinkHref: "#glyph-4-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 365.67322,
    y: 308.06421,
    xlinkHref: "#glyph-4-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 362.42456,
    y: 308.06421,
    xlinkHref: "#glyph-4-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 358.67648,
    y: 308.06421,
    xlinkHref: "#glyph-4-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 356.17477,
    y: 308.06421,
    xlinkHref: "#glyph-4-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 353.67303,
    y: 308.06421,
    xlinkHref: "#glyph-4-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 351.17133,
    y: 308.06421,
    xlinkHref: "#glyph-4-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 348.66959,
    y: 308.06421,
    xlinkHref: "#glyph-4-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 346.16788,
    y: 308.06421,
    xlinkHref: "#glyph-4-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 343.66614,
    y: 308.06421,
    xlinkHref: "#glyph-4-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 340.66498,
    y: 308.06421,
    xlinkHref: "#glyph-4-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 337.66382,
    y: 308.06421,
    xlinkHref: "#glyph-4-32"
  }), /*#__PURE__*/React.createElement("use", {
    x: 335.16208,
    y: 308.06421,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 333.91122,
    y: 308.06421,
    xlinkHref: "#glyph-4-0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Luzara);
export default __webpack_public_path__ + "static/media/4luzara.eb5f50e7335a88cb7797888fff9bd8a8.svg";
export { ForwardRef as ReactComponent };